import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import React, { useEffect, useMemo, useState } from "react";
import Lottie from "react-lottie";
import { useNavigate, useParams } from "react-router-dom";
import successAnimation from "../../assets/gifs/gif_success.json";
import { Button, Img, SelectBox, Spinner, Text } from "../../components";
import { Capitalize } from "../../utils/index";
import ReactSelect, { SingleValue } from "react-select";
import {
  Sheet,
  SheetContent,
  SheetOverlay,
  SheetPortal,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
const statusOptionsList = [
  { label: "Active", value: "active" },
  { label: "In-active", value: "inactive" },
];
import * as Switch from "@radix-ui/react-switch";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const bankStatusOptionsList = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "unverified", label: "Unverified" },
  { value: "incomplete", label: "Incomplete" },
];
import DocPopup from "pages/Create Opportunities/popup/docpopup";
import EmailPopup from "pages/Create Opportunities/popup/emailpopup";
import editpng from "../../assets/images/icon _edit_.png";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { createColumnHelper } from "@tanstack/react-table";
import axios, { AxiosRequestConfig } from "axios";
import NavbarWithActions from "components/Navbar/navbarwithactions";
import CommissionRateTable from "components/PartnerDetailTable";
import Confirm from "models/Confirm";
import AddBankAccountStep from "models/PartnerDetails/AddBankAccountStep";
import BankAccountVerification from "models/PartnerDetails/BankAccountVerification";
import EnableGIC from "models/PartnerDetails/EnableGIC";
import ProductActivation from "models/PartnerDetails/ProductActivation";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  BranchDetailsType,
  CommissionRateTableRowType,
  DeleteBankAccountRequestType,
  GetCommisionRateRequestType,
  GetPartnerDetailsRequestType,
  PostApprovalCommisionRateRequestType,
  ProductRowType,
  PutActivateRequestType,
  PutDeactivateRequestType,
  ToggleCheckListRequestType,
  deleteBankAccount,
  getAllProducts,
  getCommisionRate,
  getPartnerDetails,
  postApprovalCommisionRate,
  putActivate,
  putDeactivate,
  toggleCheckList,
} from "service/apis/PartnerDetails";
import {
  getCommisionRatesStep5,
  postUpdateCommisionRatesStep5,
} from "service/apis/PartnerRegistrationapi";
import {
  PatchSettingAccessReqType,
  patchSettingAccess,
} from "service/apis/RedirectPortal";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { toast } from "sonner";
import deleteSvg2 from "../../assets/images/icon_delete.svg";
import { setResumeForm } from "../../redux/features/PartnerRegistration";
import Product from "./Productaddedit";
import { DataTable } from "components/Table/DataTable";
import { PartnerInteractionType } from "@/lib/validations/schema";
import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "components/Table/data-table-column-header";
import { channel_options, opportunity_status_options } from "common/filters";
import { ChannelOptions } from "pages/Leads/lead";
import {
  postAddInteractions,
  PostAddInteractionsReqType,
  postCorporateInteractions,
  PostCorporateInteractionsReqType,
  putUpdateInteractionStatus,
  PutUpdateInteractionStatusReqType,
  RequestDocReqType,
} from "service/apis/Opportunities";
import {
  channel_options_inbound,
  channel_options_outbound,
  getRelativeDate,
} from "pages/Opportunities/utils/featureRule";
import { DateTimePicker } from "pages/Opportunities/dateandtime";
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronDown, X, XIcon } from "lucide-react";
import { FormProvider, useForm } from "react-hook-form";
import PhotoUpload from "pages/Opportunities/PhotoUpload";
import {
  getAllStaff,
  GetAllStaffRequestType,
} from "service/apis/StaffDetailsapi";
import { useIsMobile } from "@/hooks/use-mobile";
import { convertFileToBase64 } from "pages/CreateRemit/documentation";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ForexOrderInteractionCard } from "./Common/interactionCard";
import { Option } from "./types";

type checkListType = Partial<{
  task: string;
  value: boolean;
  can_user_tick: boolean;
}>;

type statetype = Partial<{
  id: string | number;
  name: string;
  created_at: number;
  phone: string;
  email: string;
  status?: string;
  pan_type: string;
  type: string;
  pan: {
    url: string;
  };
  aadhar_front: {
    url: string;
  };
  address_proof: {
    url: string;
  };
  masked_pan_no: string;
  masked_aadhar_no: string;
  _realtionship_manager_channels: any;
  _onboarding_checklist: {
    id: string;
    checklist: checkListType[];
  };
  aadhar_back: string;
  gst_number: string;
  branch_type: any;
  extra_detail: any;
  _created_byName: any;
  _rm_name: any;
  _branch: any;
  _channel_commission: any;
  approval_status: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  pincode: string;
  property_type: string;
  office_photos?: { url: string }[];
  photos?: { url: string }[];
  _created_by: {
    id: number;
    fname: string;
    phone_number: string;
    email: string;
  };
  _rm: {
    fname: string;
  };
}>;
type commisionratedata = Partial<{
  purpose_id: string | number;
  margin: string;
  propose_margin: string;
  purpose: string;
}>;

export type BankDetailsRowType = {
  id: string | number;
  status: string;
  bank_name: string;
  account_number: string;
  ifsc_code: string;
  primary_account: boolean;
};

const PartnerDetailsPage: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [fileBinary, setFileBinary] = useState<string | null>(null);
  const { id } = useParams();
  const param = useParams();
  const methods2 = useForm();
  const isMobile = useIsMobile();
  const [state, setState] = React.useState<statetype>({
    id: "",
    name: "",
    created_at: 0,
    phone: "",
    email: "",
    status: "",
    pan_type: "",
    type: "",
    pan: { url: "" },
    aadhar_front: { url: "" },
    address_proof: { url: "" },
    masked_pan_no: "",
    masked_aadhar_no: "",
    _realtionship_manager_channels: null,
    _onboarding_checklist: { id: "", checklist: [] },
    aadhar_back: "",
    gst_number: "",
    branch_type: null,
    extra_detail: null,
    _created_byName: "",
    _rm_name: "",
    _branch: null,
    _channel_commission: null,
    approval_status: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    pincode: "",
    property_type: "",
    office_photos: [],
    photos: [],
    _created_by: {
      id: 0,
      fname: "",
      phone_number: "",
      email: "",
    },
    _rm: {
      fname: "",
    },
  });
  const [CommissionRateTableRow, setCommissionRateTableRow] = React.useState<
    CommissionRateTableRowType[]
  >([]);
  const [isInteractionModal, setIsInteractionModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isNextBtn, setIsNextBtn] = useState<Boolean>(false);
  const [isUploadScreen, setISUploadScreen] = useState<Boolean>(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const [showimg, setShowimg] = useState(false);
  const [showGICModal, setShowGICModal] = useState(false);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showOnboardingChecklist, setShowOnboardingChecklist] = useState(true);
  const [imgsrc, setImgsrc] = useState("");
  const [product, setProduct] = useState<number>(0);
  const [productStatus, setProductStatus] = useState<string>("");
  const [editproposemargin, setEditproposemargin] = useState<string | number>(
    ""
  );
  const [productOptionsList, setProductOptionsList] = useState<
    ProductRowType[]
  >([]);
  const [productDetails, setProductDetails] = useState<any>({});
  const [commisionrate, setCommisionrate] = useState<any[]>([]);
  const [commisionratedata, setCommisionratedata] = useState<
    commisionratedata[]
  >([]);
  const [updatecommisionratedata, setUpdatecommisionratedata] = useState<
    commisionratedata[]
  >([]);
  const [editBankRow, setEditBankRow] = useState<string>("");
  const [bankAccounts, setBankAccounts] = useState<BankDetailsRowType[]>([]);
  const [verifyBankAccount, setVerifyBankAccount] = useState<string | number>(
    ""
  );
  const [interactionNote, setInteractionNote] = useState("");
  const [selectedStaffOptions, setSelectedStaffOptions] = useState<Option[]>(
    []
  );
  const [selectedType, setSelectedType] = useState<string>("");
  const [selectedChannelOption, setSelectedChannelOption] =
    useState<string>("");
  const [selectedContact, setSelectedContact] = useState<string>("");
  const [contactType, setContactType] = useState<string>("");
  const [popupnotes, setPopupNotes] = useState<string>("");
  const [channel, setChannel] = useState("whatsapp");
  const [channelDetails, setChannelDetails] = useState<{
    channel: string;
    source: string;
  }>();
  const [interactionList, setInteractionList] = useState<
    PartnerInteractionType[]
  >([]);
  const [meetingTime, setMeetingTime] = useState<Date>();
  const [date, setDate] = useState<Date>();
  const [toggleEnabled, setToggleEnabled] = useState<boolean>(false);
  const [isToggled, setIsToggled] = useState(false);
  const [toggledProduct, setToggledProduct] = useState<number | null>(null);
  const [checkList, setCheckList] = useState<checkListType[]>([]);
  const [isCheckListUpdated, setCheckListUpdated] = useState<boolean>(false);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState();
  const [opportunityDetails, setOpportunityDetails] = useState<any>({});
  const [status1, setStatus] = useState<any>();
  const [updatestatus, setUpdatestatus] = useState("");
  const [contactDetails, setContactDetails] = useState<{
    contactPerson: string;
    contactEmail: string;
    contactNumber: string;
    location: string;
    notes: string;
    oppId: string;
    contactId: string;
    createDate: string;
    createdBy: string;
    type: string;
    city: string;
    _created_by: {
      fname: string;
    };
    _rm: {
      id: string;
      fname: string;
    };
    lead_status: string;
  }>();
  const [primaryContact, setPrimaryContact] = useState<{
    contactName: string;
    contactNumber: string;
    contactEmail: string;
    channels_id: number;
    linked_partner_id: number;
    isPrimary: boolean;
    partner_link_time: number | null;
    partner_linked_by: number;
  }>({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    channels_id: 0,
    linked_partner_id: 0,
    isPrimary: false,
    partner_link_time: null,
    partner_linked_by: 0,
  });
  const [teamMember, setTeamMember] = useState<
    {
      id: number;
      contactName: string;
      contactNumber: string;
      contactEmail: string;
      channels_id: string;
      linked_partner_id: string;
      partner_link_time: number;
      _partner_linked_by: object;
      isPrimary: boolean;
      relation_with_partner: string;
    }[]
  >([]);
  const [extraDetails, setExtraDetails] = useState<any>();
  const [selectedMode, setSelectedMode] = useState<string[]>([]);
  const [expires, setExpires] = useState("1");
  const [loading, setLoading] = useState(false);
  const [enableGIC, setEnableGIC] = useState<boolean>(false);
  const [branchdetails, setBranchdetails] = useState<BranchDetailsType[]>([]);
  const [staffs, setStaffs] = useState<Option[]>([]);
  const [location, setLocation] = useState<{
    latitude: string;
    longitude: string;
  } | null>(null);
  const { pipelineType } = useAppSelector((state) => state.CreateOpportunity);

  const handleDialogOpen = (val: boolean) => {
    setDialogOpen(val);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleSelect = (value: any) => {
    setActiveTab(value);
    setIsOpen(false);
  };

  const handleMobileFileChange = (file: File) => {
    if (!file.type.startsWith("image/")) {
      alert("Please upload only image files");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      setPreviewUrl(base64);
      methods2.setValue("office_photo", base64, { shouldValidate: true });
    };
    reader.readAsDataURL(file);
  };

  const getOpportunity = async () => {
    try {
      const auth = localStorage.getItem("authToken");
      if (!auth) return;

      const authToken = JSON.parse(auth);
      const payload: AxiosRequestConfig<GetPartnerDetailsRequestType> = {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          channels_id: param?.id,
        },
      };

      const response: any = await getPartnerDetails(payload);
      if (!response?.data) return;

      const channelInfo = response?.data?.channel_info;
      if (!channelInfo) return;
      // Set team member data with proper null checking
      if (
        Array.isArray(response?.data?.team_member) &&
        response?.data?.team_member.length > 0
      ) {
        setTeamMember(response.data.team_member);
      } else {
        setTeamMember([
          {
            id: channelInfo?.id,
            contactName: channelInfo?.name,
            contactNumber: channelInfo?.phone,
            contactEmail: channelInfo?.email,
            channels_id: channelInfo?.channels_id,
            linked_partner_id: channelInfo?.linked_partner_id,
            partner_link_time: channelInfo?.partner_link_time,
            _partner_linked_by: channelInfo?._partner_linked_by,
            isPrimary: channelInfo?.isPrimary,
            relation_with_partner: channelInfo?.relation_with_partner,
          },
        ]);
      }

      setOpportunityDetails({});
      setProductDetails({});
      setContactDetails(() => {
        return {
          contactPerson: channelInfo?.name,
          contactEmail: channelInfo?.email,
          contactNumber: channelInfo?.phone || "NA",
          location: channelInfo?.city,
          notes: "",
          contactId: channelInfo?.id,
          oppId: "",
          lead_status: channelInfo?.lead_status,
          createDate: getRelativeDate(channelInfo?.created_at),
          type: channelInfo?.type,
          _created_by: {
            fname: channelInfo?._created_by?.fname,
          },
          _rm: {
            fname: channelInfo?._rm?.fname,
          },
        };
      });

      setExtraDetails(channelInfo?.extra_detail || {});
      setChannelDetails({});
      // Set team member data from the response
      if (
        response?.data?.team_member &&
        Array.isArray(response?.data?.team_member)
      ) {
        setTeamMember(response?.data?.team_member);
        const primary = response?.data?.team_member.find(
          (member) => member?.isPrimary === true
        );

        if (primary) {
          setPrimaryContact({
            contactName: primary?.contactName,
            contactNumber: primary?.contactNumber,
            contactEmail: primary?.contactEmail,
          });
        }
      } else {
        console.warn(
          "Invalid team_member data received:",
          response?.data?.team_member
        );
        setTeamMember([
          {
            id: response?.data.id,
            contactName: response?.data?.name,
            contactNumber: response?.data?.phone,
            contactEmail: response?.data?.email,
            channels_id: response?.data?.channels_id,
            linked_partner_id: response?.data?.linked_partner_id,
            partner_link_time: response?.data?.partner_link_time,
            _partner_linked_by: response?.data?._partner_linked_by,
            isPrimary: response?.data?.isPrimary,
            relation_with_partner: response?.data?.relation_with_partner,
          },
        ]);
      }

      setStatus(() => {
        const status = opportunity_status_options.find(
          (status) =>
            status.value === (channelInfo.status === "lead" ? "open" : "close")
        );
        return status;
      });

      // Set interaction list data
      const updatedList =
        channelInfo.interactions_id
          ?.sort((a: any, b: any) => {
            const dateA = new Date(a[0]?.created_at).getTime();
            const dateB = new Date(b[0]?.created_at).getTime();
            return dateB - dateA;
          })
          .map((interaction: any) => {
            const interactionData = interaction[0];
            return {
              id: interactionData.id,
              createdAt: getRelativeDate(interactionData?.created_at),
              contactedBy:
                interactionData?.channel_of_interaction_id === 3
                  ? interactionData.meetingStaff_id?.map(
                      (staff: any) => staff.fname
                    )
                  : interactionData?.createdBy,
              contatedTo: interactionData._contacts?.[0]?.contactName ?? "N/A",
              channel: interactionData._channel_of_interaction?.[0]?.Channel,
              channelType: interactionData._channel_of_interaction?.[0]?.Type,
              note: interactionData.note,
              selfie: interactionData?.selfie?.url,
            };
          }) ?? [];

      setInteractionList([...updatedList]);
    } catch (error) {
      console.error("Error fetching opportunity details:", error);
      setTeamMember([]);
    }
  };

  const handleUpdateInteractionStatus = async (id: string) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<PutUpdateInteractionStatusReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        id,
        isOpen: "false",
      },
    };
    try {
      const res = (await putUpdateInteractionStatus(payload)) as any;
      if (res.status === 200) {
        toast.success("Interaction status updated successfully");
        await getOpportunity();
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update interaction status");
      setLoading(false);
    }
  };

  const InteractionColumn = useMemo<ColumnDef<PartnerInteractionType>[]>(
    () => [
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Date and Time" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex flex-col gap-1.5">
              <p className="">{row.original.createdAt}</p>
              <p className="capitalize font-normal text-sm text-[#666666]">
                {row?.original?.createdBy}
              </p>
            </div>
          );
        },
      },
      {
        accessorKey: "contactedBy",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Contacted By" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-1.5">
              <div className="flex flex-col gap-1">
                {row?.original?.contactedBy?.length > 0 ? (
                  <p className="capitalize whitespace-nowrap font-normal text-sm text-[#666666]">
                    {row?.original?.contactedBy?.[0]}
                    <span>
                      {row?.original?.contactedBy?.length > 1 &&
                        ` + ${row?.original?.contactedBy?.length - 1} more`}
                    </span>
                  </p>
                ) : (
                  <p className="capitalize whitespace-nowrap font-normal text-sm text-[#666666]">
                    <span>{row?.original?.contactedBy?.fname || "N/A"}</span>
                  </p>
                )}
              </div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="w-full flex items-end " asChild>
                    <div className="pt-1">
                      {row?.original?.contactedBy?.length > 0 && (
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.23438 0.09375C5.86845 0.09375 4.5332 0.498795 3.39747 1.25766C2.26174 2.01653 1.37655 3.09514 0.853835 4.35709C0.331117 5.61904 0.194351 7.00766 0.46083 8.34734C0.727309 9.68702 1.38507 10.9176 2.35092 11.8835C3.31678 12.8493 4.54735 13.5071 5.88704 13.7735C7.22672 14.04 8.61533 13.9033 9.87729 13.3805C11.1392 12.8578 12.2178 11.9726 12.9767 10.8369C13.7356 9.70118 14.1406 8.36593 14.1406 7C14.1387 5.16894 13.4105 3.41343 12.1157 2.11868C10.8209 0.823925 9.06544 0.0956836 7.23438 0.09375ZM6.96875 3.28125C7.12636 3.28125 7.28043 3.32799 7.41147 3.41555C7.54252 3.50311 7.64466 3.62756 7.70497 3.77317C7.76528 3.91878 7.78106 4.07901 7.75032 4.23359C7.71957 4.38817 7.64367 4.53016 7.53223 4.6416C7.42078 4.75305 7.27879 4.82894 7.12422 4.85969C6.96964 4.89044 6.80941 4.87466 6.6638 4.81434C6.51819 4.75403 6.39374 4.65189 6.30618 4.52084C6.21861 4.3898 6.17188 4.23573 6.17188 4.07812C6.17188 3.86678 6.25583 3.66409 6.40528 3.51465C6.55472 3.36521 6.75741 3.28125 6.96875 3.28125ZM7.76563 10.7188C7.48384 10.7188 7.21358 10.6068 7.01433 10.4076C6.81507 10.2083 6.70313 9.93804 6.70313 9.65625V7C6.56223 7 6.42711 6.94403 6.32748 6.8444C6.22785 6.74477 6.17188 6.60965 6.17188 6.46875C6.17188 6.32785 6.22785 6.19273 6.32748 6.0931C6.42711 5.99347 6.56223 5.9375 6.70313 5.9375C6.98492 5.9375 7.25517 6.04944 7.45443 6.2487C7.65369 6.44796 7.76563 6.71821 7.76563 7V9.65625C7.90652 9.65625 8.04165 9.71222 8.14128 9.81185C8.24091 9.91148 8.29688 10.0466 8.29688 10.1875C8.29688 10.3284 8.24091 10.4635 8.14128 10.5632C8.04165 10.6628 7.90652 10.7188 7.76563 10.7188Z"
                            fill="#666666"
                          />
                        </svg>
                      )}
                    </div>
                  </TooltipTrigger>
                  <TooltipContent className="bg-black-label border-0">
                    <p className="bg-black-label text-white-A700">
                      {row?.original?.contactedBy?.length
                        ? row?.original?.contactedBy
                            ?.map((staff: any) => {
                              return staff;
                            })
                            .join(", ")
                        : "No staffs available"}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "contatedTo",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Contacted With" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex items-center justify-between gap-1.5">
              <p className="max-w-[200px] whitespace-normal break-words">
                {row.original.contatedTo}
              </p>
            </div>
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "channel",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Channel" />
        ),
        cell: ({ row }) => {
          const newSource = (channel_options as ChannelOptions)?.[
            row?.original?.channelType?.toLowerCase()
          ]?.find(
            (item) =>
              item.value?.toLowerCase() ===
              (row.getValue("channel") as string)
                ?.toLowerCase()
                .split(" ")
                .join("")
          );

          if (newSource?.value === "meeting") {
            return (
              <div className="h-full max-w-[100px] items-start flex gap-10 ">
                <div className="flex flex-col gap-1">
                  <p className="capitalize">{newSource?.label}</p>
                  <p className="capitalize text-gray-500">
                    {row?.original?.channelType}
                  </p>
                </div>
              </div>
            );
          }

          return newSource?.value ? (
            <div className="h-full flex flex-col gap-2">
              <div className="h-full w-[100px] flex gap-10">
                <p className="capitalize w-full whitespace-nowrap">
                  {newSource?.label}
                </p>
                <Img
                  className="text-right flex items-end h-5 w-5"
                  src={newSource?.icon}
                  alt="icon"
                />
              </div>
              <p className="capitalize text-gray-500">
                {row?.original?.channelType}
              </p>
            </div>
          ) : (
            <p className="capitalize">{row?.original?.channelType}</p>
          );
        },
        filterFn: (row, id, value) => {
          return String(row.getValue(id))
            .toLowerCase()
            .includes(String(value).toLowerCase());
        },
        enableSorting: false,
      },
      {
        accessorKey: "note",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Note" />
        ),
        filterFn: (row, id, value) => {
          return String(row.getValue(id))
            .toLowerCase()
            .includes(String(value).toLowerCase());
        },
        cell: ({ row }) => {
          return (
            <div className="flex items-center justify-between gap-1.5">
              <p className="max-w-[200px] whitespace-normal break-words">
                {row.original.note}
              </p>
              {row.original.selfie && (
                <a
                  href={row.original.selfie}
                  download="image"
                  target="_blank"
                  className=""
                >
                  <svg
                    width="24"
                    height="23"
                    viewBox="0 0 24 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.2079 17.6048C21.2782 17.6751 21.3177 17.7705 21.3177 17.87C21.3177 17.9694 21.2782 18.0648 21.2079 18.1351L19.6156 19.7274C19.5453 19.7976 19.4499 19.837 19.3505 19.837C19.251 19.837 19.1557 19.7976 19.0853 19.7274L17.493 18.1351C17.4226 18.0648 17.3831 17.9694 17.3832 17.8699C17.3832 17.7704 17.4227 17.675 17.493 17.6047C17.5634 17.5344 17.6588 17.4949 17.7583 17.4949C17.8577 17.4949 17.9531 17.5345 18.0234 17.6048L18.9755 18.5568V15.5437C18.9755 15.4443 19.015 15.3489 19.0853 15.2786C19.1556 15.2082 19.251 15.1687 19.3505 15.1687C19.4499 15.1687 19.5453 15.2082 19.6156 15.2786C19.686 15.3489 19.7255 15.4443 19.7255 15.5437V18.5568L20.6776 17.6048C20.748 17.5346 20.8434 17.4952 20.9428 17.4952C21.0422 17.4952 21.1375 17.5346 21.2079 17.6048H21.2079ZM23.2213 17.9728C23.3457 16.9462 23.0573 15.9123 22.4195 15.0983C21.7817 14.2843 20.8468 13.757 19.8203 13.6322C19.6618 13.6129 19.5022 13.6031 19.3425 13.603C18.5917 13.6044 17.8572 13.8227 17.2274 14.2314C16.5975 14.6402 16.0991 15.2221 15.7919 15.9073C15.4848 16.5924 15.382 17.3517 15.4959 18.0939C15.6097 18.836 15.9355 19.5295 16.4339 20.0911C16.9324 20.6526 17.5824 21.0583 18.3058 21.2594C19.0292 21.4606 19.7953 21.4485 20.5121 21.2248C21.2288 21.0011 21.8658 20.5752 22.3463 19.9983C22.8269 19.4214 23.1307 18.718 23.2213 17.9726V17.9728ZM2.94998 19.515H15.1577C14.7973 18.7632 14.6456 17.9283 14.7185 17.0978C14.7914 16.2672 15.0862 15.4715 15.5721 14.794C16.058 14.1165 16.7171 13.5821 17.4804 13.2467C18.2437 12.9113 19.0832 12.7873 19.9109 12.8876C20.0698 12.9071 20.2277 12.9345 20.384 12.9697V10.0166L17.9141 7.54684L12.7912 11.24L14.3185 12.3106C14.3597 12.3385 14.3949 12.3743 14.4221 12.4159C14.4492 12.4576 14.4679 12.5042 14.4769 12.5532C14.4859 12.6021 14.485 12.6523 14.4744 12.7009C14.4638 12.7495 14.4437 12.7955 14.4151 12.8362C14.3866 12.8769 14.3502 12.9116 14.3081 12.9381C14.2661 12.9647 14.2191 12.9826 14.1701 12.9908C14.121 12.999 14.0708 12.9974 14.0224 12.986C13.974 12.9747 13.9283 12.9538 13.888 12.9246L6.19116 7.52931L0.754078 12.1268C0.752719 12.1279 0.751125 12.129 0.749766 12.1301V17.3145C0.750349 17.8978 0.982338 18.4572 1.39483 18.8697C1.80732 19.2822 2.36661 19.5142 2.94998 19.5149V19.515ZM2.94998 1.59747H18.1836C18.7669 1.59813 19.3261 1.83014 19.7386 2.24261C20.1511 2.65508 20.3831 3.21432 20.3838 3.79764V8.95623L18.2186 6.79117C18.1557 6.72819 18.0724 6.68967 17.9836 6.68249C17.8948 6.67532 17.8064 6.69997 17.7342 6.75203L12.141 10.7842L6.3847 6.74917C6.31685 6.70167 6.23519 6.67795 6.15244 6.68171C6.0697 6.68546 5.99052 6.71649 5.92725 6.76994L0.75 11.1482V3.79773C0.75067 3.21445 0.982662 2.65525 1.39509 2.24278C1.80752 1.83032 2.3667 1.59828 2.94998 1.59756V1.59747ZM23.01 14.6359C22.5188 14.0054 21.8723 13.5132 21.1337 13.2075V3.79773C21.1328 3.01559 20.8217 2.26575 20.2686 1.7127C19.7156 1.15964 18.9657 0.848549 18.1836 0.847656H2.94998C2.16787 0.848599 1.41807 1.15972 0.865039 1.71276C0.312011 2.26581 0.000917972 3.01562 0 3.79773L0 17.3147C0.0007446 18.0969 0.311806 18.8469 0.864916 19.4C1.41803 19.9531 2.16799 20.2642 2.95022 20.265H15.6112C15.6371 20.3007 15.6638 20.3358 15.6911 20.3705C16.4543 21.3329 17.5674 21.9542 18.7872 22.0986C20.007 22.2431 21.2343 21.8989 22.2012 21.1414C23.1681 20.3838 23.7958 19.2744 23.9474 18.0555C24.0989 16.8365 23.762 15.6072 23.01 14.6359ZM11.8242 4.26283C12.1642 4.26283 12.4966 4.36364 12.7792 4.55253C13.0619 4.74141 13.2823 5.00988 13.4124 5.32398C13.5425 5.63809 13.5765 5.98372 13.5102 6.31717C13.4439 6.65062 13.2802 6.95692 13.0398 7.19733C12.7993 7.43774 12.4931 7.60146 12.1596 7.66779C11.8262 7.73413 11.4805 7.70009 11.1664 7.56999C10.8523 7.43989 10.5838 7.21957 10.3949 6.93689C10.2061 6.65421 10.1052 6.32186 10.1052 5.98188C10.1058 5.52614 10.287 5.08922 10.6093 4.76696C10.9316 4.44471 11.3685 4.26344 11.8242 4.26292V4.26283ZM11.8242 8.45088C11.3359 8.45088 10.8585 8.30608 10.4524 8.03477C10.0464 7.76347 9.72992 7.37785 9.54303 6.92667C9.35615 6.4755 9.30725 5.97904 9.40252 5.50008C9.4978 5.02112 9.73296 4.58116 10.0783 4.23585C10.4236 3.89054 10.8636 3.65539 11.3425 3.56012C11.8215 3.46486 12.3179 3.51377 12.7691 3.70066C13.2203 3.88755 13.6059 4.20404 13.8772 4.61009C14.1485 5.01614 14.2933 5.49353 14.2933 5.98188C14.2925 6.63647 14.0321 7.26404 13.5693 7.7269C13.1064 8.18977 12.4788 8.45013 11.8242 8.45088Z"
                      fill="#165FE3"
                    />
                  </svg>
                </a>
              )}
            </div>
          );
        },
        enableSorting: false,
      },
    ],
    [handleUpdateInteractionStatus]
  );

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(setResumeForm(false));
    PartnerDetails();
  }, []);

  React.useEffect(() => {
    if (
      product != 0 &&
      productStatus != "" &&
      CommissionRateTableRow &&
      CommissionRateTableRow.length > 0
    ) {
      if (productStatus !== "approved") {
        fetchCommisionRates();
      } else {
        setCommisionratedata(
          state?._channel_commission
            ?.filter((e: any) => e.product_id === product)
            ?.map((e: any) => {
              return {
                purpose_id: e?.purpose_id,
                margin: e?.charges,
                purpose: e?._purpose?.name,
              };
            })
        );
      }
    }
  }, [CommissionRateTableRow, product, productStatus]);

  // Fetching Commision Rates
  const fetchCommisionRates = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<GetCommisionRateRequestType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: {
        product_id: product,
      },
    };
    setLoading(true);
    getCommisionRate(req)
      .then((res) => {
        if (res.data instanceof Array) {
          const data = res.data
            .map((e: any) => {
              const findone: CommissionRateTableRowType | undefined =
                CommissionRateTableRow.find(
                  (a: commisionratedata) => a.purpose_id === e.purpose_id
                );
              if (!findone)
                return {
                  purpose_id: "",
                  margin: "",
                  propose_margin: "",
                  purpose: "",
                };
              return {
                purpose_id: findone.id,
                margin: e.charges,
                propose_margin: findone.proposed_charges,
                purpose: e._purpose_mapper.name,
              };
            })
            .filter((e: any) => e.purpose_id !== "");
          setCommisionratedata(data);

          const proposedData = res.data
            .map((e: any) => {
              const findone: CommissionRateTableRowType | undefined =
                CommissionRateTableRow.find(
                  (a: commisionratedata) => a.purpose_id === e.purpose_id
                );
              if (!findone)
                return {
                  purpose_id: "",
                  margin: "",
                  propose_margin: "",
                  purpose: "",
                };
              return {
                commision_rates_id: findone.id,
                charges: findone.proposed_charges,
              };
            })
            .filter((e: any) => e.purpose_id !== "");
          setUpdatecommisionratedata(proposedData);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // Fetching Partner Details
  const PartnerDetails = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<GetPartnerDetailsRequestType> = {
      data: {
        channels_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    getPartnerDetails(req)
      .then((res) => {
        // Map branch details
        if (res?.data?._branch) {
          setBranchdetails(res.data?._branch);
        }
        // Set main state with channel info
        const ChannelInfoData = res?.data?.channel_info;

        const getValueOrNA = (value: any, fallback = "NA") => {
          return value && value !== "" ? value : fallback;
        };

        setState({
          id: getValueOrNA(ChannelInfoData?.id),
          name: getValueOrNA(ChannelInfoData?.name),
          phone: getValueOrNA(ChannelInfoData?.phone),
          email: getValueOrNA(ChannelInfoData?.email),
          status: getValueOrNA(ChannelInfoData?.status),
          pan_type: getValueOrNA(ChannelInfoData?.pan_type),
          type: getValueOrNA(ChannelInfoData?.type),
          pan: ChannelInfoData?.pan?.url ? ChannelInfoData.pan : { url: "NA" },
          aadhar_front: ChannelInfoData?.aadhar_front?.url
            ? ChannelInfoData.aadhar_front
            : { url: "NA" },
          aadhar_back: getValueOrNA(ChannelInfoData?.aadhar_back),
          address_proof: ChannelInfoData?.address_proof?.url
            ? ChannelInfoData.address_proof
            : { url: "NA" },
          masked_pan_no: getValueOrNA(ChannelInfoData?.masked_pan_no),
          masked_aadhar_no: getValueOrNA(ChannelInfoData?.masked_aadhar_no),
          approval_status: getValueOrNA(ChannelInfoData?.approval_status),
          address_line_1: getValueOrNA(ChannelInfoData?.address_line_1),
          address_line_2: getValueOrNA(ChannelInfoData?.address_line_2),
          city: getValueOrNA(ChannelInfoData?.city),
          state: getValueOrNA(ChannelInfoData?.state),
          pincode: getValueOrNA(ChannelInfoData?.pincode),
          property_type: getValueOrNA(ChannelInfoData?.property_type),
          photos:
            ChannelInfoData?.photos?.length > 0
              ? ChannelInfoData.photos
              : [{ url: "NA" }],
          gst_number: getValueOrNA(ChannelInfoData?.gst_number),
          branch_type: getValueOrNA(ChannelInfoData?.branch_type),
          extra_detail: getValueOrNA(ChannelInfoData?.extra_detail),
          _created_byName: getValueOrNA(ChannelInfoData?._created_by?.fname),
          created_at: getValueOrNA(ChannelInfoData?.created_at),
          _rm_name: getValueOrNA(ChannelInfoData?._rm?.fname),
        });
        setInteractionList(
          ChannelInfoData?.interactions_id?.map((interaction: any) => {
            const interactionData = interaction[0];
            return {
              id: interactionData.id,
              createdAt: getRelativeDate(interactionData.created_at),
              contactedBy:
                interactionData?.channel_of_interaction_id === 3
                  ? interactionData.meetingStaff_id?.map(
                      (staff: any) => staff.fname
                    )
                  : interactionData?.createdBy,
              contatedTo: interactionData._contacts?.[0]?.contactName ?? "N/A",
              channel: interactionData._channel_of_interaction?.[0]?.Channel,
              channelType: interactionData._channel_of_interaction?.[0]?.Type,
              note: interactionData.note,
              selfie: interactionData?.selfie?.url,
            };
          }) ?? []
        );

        // Set checklist
        setCheckList(ChannelInfoData?._onboarding_checklist?.checklist ?? []);
        const isCompleted = ChannelInfoData?.checklist_completed === true;
        setShowOnboardingChecklist(!isCompleted);

        // Set status
        if (ChannelInfoData?.status) {
          setUpdatestatus(ChannelInfoData?.status);
        }

        // Set commission rates
        if (ChannelInfoData?._channel_commission) {
          setCommissionRateTableRow(ChannelInfoData?._channel_commission);
        }

        // Set bank accounts
        if (ChannelInfoData?._bank_account_of_channels) {
          setBankAccounts(ChannelInfoData?._bank_account_of_channels);
        }

        // Set products
        if (ChannelInfoData?.products) {
          setProductOptionsList(
            ChannelInfoData?.products?.map((e: any) => ({
              label: e?._product?.name,
              value: e?.product_id,
              status: e?.status,
            }))
          );

          const findGIC = ChannelInfoData?.products?.find(
            (e: any) => e.product_id === 8
          );

          if (!findGIC) {
            setEnableGIC(true);
          }
          setProduct(ChannelInfoData?.products[0]?.product_id);
          setProductStatus(ChannelInfoData?.products[0]?.status);
        }
        // Set team members if available
        if (res?.data?.team_member && res?.data?.team_member.length > 0) {
          setTeamMember(res?.data?.team_member);
        } else {
          setTeamMember([
            {
              id: ChannelInfoData?.id,
              contactName: ChannelInfoData?.name,
              contactNumber: ChannelInfoData?.phone,
              contactEmail: ChannelInfoData?.email,
              channels_id: ChannelInfoData?.channels_id,
            linked_partner_id: ChannelInfoData?.linked_partner_id,
            partner_link_time: ChannelInfoData?.partner_link_time,
            _partner_linked_by: ChannelInfoData?._partner_linked_by,
            isPrimary: ChannelInfoData?.isPrimary,
            relation_with_partner: ChannelInfoData?.relation_with_partner,
            },
          ]);
        }
      })
      .catch((error) => {
        console.error("Error fetching partner details:", error);
      });
  };

  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
  };

  // Commission rate actions buttons
  const postapprovalcommision = (data: any): void | null => {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<PostApprovalCommisionRateRequestType> = {
      data: {
        child_channel: id,
        commision_rates: data,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    postApprovalCommisionRate(req)
      .then(() => {
        setLoading(false);
        PartnerDetails();
        toast.success("Commission Rate Updated Successfully");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const deactivate = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    setLoading(true);

    const req: AxiosRequestConfig<PutDeactivateRequestType> = {
      data: {
        channels_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    putDeactivate(req)
      .then(() => {
        toast.success("Partner Deactivated Successfully");
        PartnerDetails();
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setLoading(false);
      });
  };

  const activate = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    setLoading(true);
    const req: AxiosRequestConfig<PutActivateRequestType> = {
      data: {
        channels_id: id,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    putActivate(req)
      .then(() => {
        toast.success("Partner Activated Successfully");
        PartnerDetails();
        setLoading(false);
      })
      .catch((err) => {
        setUpdatestatus("inactive");
        toast.error(err.response.data.message);
        setLoading(false);
      });
  };

  const resumeRegistration = (): void | null => {
    dispatch(setResumeForm(true));
    localStorage.setItem("child_channel_id", id);
    navigate(`/partnerregistration`);
  };

  const handleonChangeStatus = (e: string) => {
    if (e === "inactive") {
      deactivate();
    }
    if (e === "active") {
      activate();
    }
  };

  const CommisionTableColumn: any = React.useMemo(() => {
    const tableColumnHelper = createColumnHelper<CommissionRateTableRowType>();
    const columns = [
      tableColumnHelper.accessor("purpose", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[250px]  px-[30px] flex items-center justify-left text-blue_gray-900_01 text-sm">
            Purpose
          </Text>
        ),
        cell: (props) => (
          <Text className="font-medium sm:px-5 h-[60px] w-[250px] px-[30px]  flex items-center justify-left text-blue_gray-900_01 text-sm">
            {props.getValue()}
          </Text>
        ),
      }),
      tableColumnHelper.accessor("margin", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            Margin
          </Text>
        ),
        cell: (props) => (
          <Text className="font-medium sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            {props.getValue()} {`${product === 8 ? "(CAD)" : ""}`}
          </Text>
        ),
      }),
    ];
    // Check approval_status before adding the action buttons
    if (productStatus && productStatus !== "approved") {
      columns.push(
        tableColumnHelper.accessor("propose_margin", {
          header: () => (
            <Text className="font-semibold sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
              Proposed Margin
            </Text>
          ),
          cell: (props) =>
            editproposemargin === props.row.original.purpose_id ? (
              <input
                type="text"
                className="font-medium sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm"
                value={props?.getValue()}
                onChange={(e) => {
                  const data = commisionratedata.map((item: any) => {
                    if (item.purpose_id === props.row.original.purpose_id) {
                      return {
                        ...item,
                        propose_margin:
                          e.target.value !== "" ? e.target.value : "",
                      };
                    }
                    return item;
                  });
                  setCommisionratedata(data);

                  let data1: any = updatecommisionratedata.filter(
                    (item: any) =>
                      item.commision_rates_id !== props.row.original.purpose_id
                  );
                  data1.push({
                    commision_rates_id: props.row.original.purpose_id,
                    charges: e.target.value !== "" ? e.target.value : "",
                  });
                  setUpdatecommisionratedata(data1);
                }}
              />
            ) : (
              <Text className="font-medium sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
                {props?.getValue()}
              </Text>
            ),
        }),
        tableColumnHelper.accessor("purpose_id", {
          header: () => (
            <Text className="font-semibold sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
              {/* Action */}
            </Text>
          ),
          cell: (props) => (
            <div className="font-semibold sm:px-5 h-[60px] w-[250px] flex items-center justify-center text-blue_gray-900_01 text-sm">
              <div className="flex justify-between w-[180px] h-[31px]">
                <Button
                  onClick={() => {
                    if (editproposemargin === props.row.original.purpose_id) {
                      setEditproposemargin("");
                    } else {
                      setEditproposemargin(props.row.original.purpose_id);
                    }
                  }}
                >
                  <Img src={editpng} alt="edit" />
                </Button>
              </div>
            </div>
          ),
        })
      );
    }
    return columns;
  }, [productStatus, product, editproposemargin]);

  const handleonclickonbranch = (id: string | number) => {
    navigate(`/branchdetails${id}`);
  };
  const BranchDetailColumn: any = React.useMemo(() => {
    const tableColumnHelper = createColumnHelper<BranchDetailsType>();
    const columns = [
      tableColumnHelper.accessor("id", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            Branch ID
          </Text>
        ),
        cell: (props) => (
          <Text
            onClick={() => handleonclickonbranch(props.row.original.id)}
            className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
          >
            {props.getValue()}
          </Text>
        ),
      }),

      tableColumnHelper.accessor("name", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            Branch Name
          </Text>
        ),
        cell: (props) => (
          <Text
            onClick={() => handleonclickonbranch(props.row.original.id)}
            className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
          >
            {props.getValue()}
          </Text>
        ),
      }),
      tableColumnHelper.accessor("address_line_1", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            Branch Location
          </Text>
        ),
        cell: (props) => (
          <>
            {props.getValue() === "" ? (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-[#3FB73D] text-sm"
              >
                In-Progress
              </Text>
            ) : (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
              >
                {props.getValue()}
              </Text>
            )}
          </>
        ),
      }),
      tableColumnHelper.accessor("city", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            City
          </Text>
        ),
        cell: (props) => (
          <>
            {props.getValue() === "" ? (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-[#3FB73D] text-sm"
              >
                In-Progress
              </Text>
            ) : (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
              >
                {props.getValue()}
              </Text>
            )}
          </>
        ),
      }),
      tableColumnHelper.accessor("gst_number", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            GST Number
          </Text>
        ),
        cell: (props) => (
          <>
            {props.getValue() === "" ? (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
              >
                N.A.
              </Text>
            ) : (
              <Text
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className="cursor-pointer font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm"
              >
                {props.getValue()}
              </Text>
            )}
          </>
        ),
      }),
      tableColumnHelper.accessor("status", {
        header: () => (
          <Text className="font-semibold sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
            Status
          </Text>
        ),
        cell: (props) => (
          <>
            <div className="font-medium sm:px-5 h-[60px] w-[150px] flex items-center justify-center text-blue_gray-900_01 text-sm">
              <button
                onClick={() => handleonclickonbranch(props.row.original.id)}
                className={`cursor-pointer bg-white-A700 p-[10px] ${
                  props.getValue() === "active"
                    ? "border border-[#3FB73D] text-[#3FB73D] border-solid"
                    : "border border-gray-900 text-blue_gray-900_01 border-solid"
                } cursor-pointer font-semibold mb-1.5 min-w-[69px] mt-4 py-1 rounded text-center text-xs`}
              >
                {" "}
                {props?.getValue()?.toUpperCase()}
              </button>
            </div>
          </>
        ),
      }),
    ];
    return columns;
  }, [branchdetails]);

  const status = state?.status;

  let partnerbgColor;
  switch (status) {
    case "active":
      partnerbgColor = "bg-[#008000]";
      break;
    case "inactive":
      partnerbgColor = "bg-[#FFA500]";
      break;
  }

  const removeBankAccount = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<DeleteBankAccountRequestType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        account_id: editBankRow,
      },
    };
    setLoading(true);
    deleteBankAccount(req)
      .then((res) => {
        PartnerDetails();
        setEditBankRow("");
        setLoading(false);
        toast.success("Bank Account Removed Successfully");
      })
      .catch((err) => {
        setEditBankRow("");
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  let partner_contract_css;
  switch (state?.zoho_contract_status) {
    case "RequestExpired":
      partner_contract_css = "border-red-400 text-red-400";
      break;
    case "RequestSubmitted":
      partner_contract_css = "border-red-400 text-white-A700 bg-red-400"; // Red
      break;
    case "RequestCompleted":
      partner_contract_css = "border-colors2 text-colors2"; // Light Green
      break;
    case "RequestRejected":
      partner_contract_css = "border-red-400 text-red-400"; // Light Green
      break;
    default:
      partner_contract_css = "border-red-400 text-red-400"; // Red
  }

  const toggleCheckBox = (checkListItem: checkListType) => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);
    setLoading(true);
    const req: AxiosRequestConfig<ToggleCheckListRequestType> = {
      data: {
        onboarding_checklist_id: state?._onboarding_checklist?.id ?? 0,
        task_obj: {
          task: checkListItem.task ?? "",
          value: !checkListItem.value ?? false,
        },
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    toggleCheckList(req)
      .then((res) => {
        setLoading(false);
        setCheckList(res?.data?.checklist?.checklist ?? []);
        const isCompleted = res?.data?.completed === true;
        setShowOnboardingChecklist(!isCompleted);
        if (isCompleted) {
          toast.success(
            <div className="flex items-center">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: successAnimation,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={50}
                width={50}
              />
              <span className="ml-2">
                Partner Checklist is updated successfully
              </span>
            </div>,
            {
              icon: false,
            }
          );
        } else {
          toast.success("Checklist updated successfully!");
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleCheckBoxClick = (checkListItem: checkListType) => {
    if (checkListItem.can_user_tick) {
      toggleCheckBox(checkListItem);
    } else {
      toast.error("Task cannot be marked manually");
    }

    // const updatedCheckList=checkList.map((checkList)=>{
    //   return checkList==checkListItem?
    //   {
    //     ...checkListItem,value:!checkListItem.value
    //   }:checkList
    // })??[];

    // setCheckListUpdated(!(JSON.stringify(updatedCheckList)==JSON.stringify(state._onboarding_checklist?.checklist)))
    // setCheckList(updatedCheckList);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setFileBinary(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSettingsToggle = async () => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    setLoading(true);

    const req: AxiosRequestConfig<PatchSettingAccessReqType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        id,
        canRedirect: state?.canRedirect === "true" ? "false" : "true",
      },
    };

    try {
      const res = (await patchSettingAccess(req)) as any;
      if (res?.data) {
        PartnerDetails();
        toast.success("Settings updated successfully");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(JSON.stringify(error));
    }
  };

  const tabsdata = [
    {
      id: 1,
      label: "Overview",
      value: "overview",
      content: "Make changes to your account here.",
    },
    {
      id: 2,
      label: "Interaction",
      value: "interaction",
      content: "Change your password here.",
    },
    {
      id: 3,
      label: "Products",
      value: "products",
      content: "Change your password here.",
    },
    {
      id: 3,
      label: "Bank Accounts Details",
      value: "bank-accounts-details",
      content: "Change your password here.",
    },
    {
      id: 4,
      label: "Other Details",
      value: "other-details",
      content: "Change your password here.",
    },
  ];
  const [activeTab, setActiveTab] = useState("overview");

  const onTabChange = (value: string) => {
    setActiveTab(value);
  };

  const fetchProducts = (): void | null => {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    getAllProducts(req)
      .then((res) => {
        const tempProducts = res.data.filter(
          (product1: any) =>
            !productOptionsList.some(
              (product2: any) => product1.id === product2.value
            )
        );
        setProductOptionsList(tempProducts);
      })
      .catch(() => {});
  };

  function fetchCommisionRatesStep5(): void | null {
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const req = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    getCommisionRatesStep5(req)
      .then((res) => {
        setCommisionrate(res.data);
      })
      .catch(() => {});
  }
  function formatUnixTimestamp(unixTimestamp: number): string {
    // No need to multiply by 1000 since input is already in milliseconds
    const date = new Date(unixTimestamp);

    const day = date.getDate().toString().padStart(2, "0");

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }
  const updatedCommisions = (): void | null => {
    const updatedOldCommision = OldCommisionRate.map((obj1: any) => {
      const correspondingObj2 = UpdateCommisionRate.find(
        (obj2: any) => obj2.purpose_id === obj1.purpose_id
      );

      // If commission exists and has a lower charge, update the charge in oldCommission
      if (correspondingObj2 && correspondingObj2.charges <= obj1.charges) {
        return { ...obj1, charges: correspondingObj2.charges };
      }

      return obj1; // No update needed
    });

    const updatedNewCommision = UpdateCommisionRate.filter(
      (obj1: any) =>
        !updatedOldCommision.some(
          (obj2: any) =>
            obj1.purpose_id === obj2.purpose_id && obj1.charges === obj2.charges
        )
    );

    const approvalNeeded = updatedOldCommision.filter((obj1: any) =>
      updatedNewCommision.some((obj2: any) => obj1.id === obj2.id)
    );
    const finalApprovalNeeded = approvalNeeded.map((obj1: any) => {
      const correspondingObj2 = updatedNewCommision.find(
        (obj2: any) => obj2.purpose_id === obj1.purpose_id
      );

      if (correspondingObj2) {
        return { ...obj1, charges: correspondingObj2.charges };
      }

      return obj1; // No update needed
    });
    const approvalNotNeeded = updatedOldCommision.filter(
      (obj1: any) =>
        !updatedNewCommision.some((obj2: any) => obj1.id === obj2.id)
    );

    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const channel_id = localStorage.getItem("child_channel_id");
    if (channel_id === null) return null;

    const req = {
      data: {
        child_channel: channel_id,
        accept_default: false,
        unapproved_commision_rates: finalApprovalNeeded,
        approved_commision_rates: approvalNotNeeded,
      },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    setLoading(true);

    postUpdateCommisionRatesStep5(req)
      .then((res) => {
        setLoading(false);
        if (res.data.channel) {
          localStorage.setItem("ApplicationId", res.data.channel.id);
          localStorage.setItem(
            "ApplicationStatus",
            res.data.channel.approval_status
          );
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message || "Something went wrong");
      });
  };

  useEffect(() => {
    fetchProducts();
    fetchCommisionRatesStep5();
  }, []);

  const getStaffs = async () => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetAllStaffRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
    };
    try {
      const res = (await getAllStaff(payload)) as any;
      const options = res.data.map((obj: any) => ({
        label: obj.fname,
        value: obj.id,
      }));
      setStaffs(options);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleAddInteraction = async () => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<PostAddInteractionsReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        meeting_time: date,
        meetingStaff_id: selectedStaffOptions?.map((staff) =>
          Number(staff.value)
        ),
        note: interactionNote,
        channel_of_interaction_id: selectedChannelOption,
        quotation_pdf: "",
        contact: selectedContact,
        partner_id: param?.id,
        selfie_image: methods2.getValues("office_photo") as string,
        geo_coordinates: {
          type: "point",
          data: {
            lng: location?.longitude as string,
            lat: location?.latitude as string,
          },
        },
      },
    };
    try {
      const res = (await postAddInteractions(payload)) as any;
      if (res.status === 200) {
        toast.success("Interaction added successfully");
        getOpportunity();
        setInteractionNote("");
        setMeetingTime(undefined);
        setSelectedStaffOptions([]);
        setSelectedContact("");
        setSelectedChannelOption("");
        setContactType("");
        methods2.reset();
        setLoading(false);
        setIsInteractionModal(false);
      }
    } catch (error) {
      toast.error("Failed to add interaction");
      setLoading(false);
    }
  };

  const requestLocation = async () => {
    setLoading(true);
    if ("geolocation" in navigator) {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLoading(false);
        return true;
      } catch (error) {
        setLoading(false);
        return false;
      }
    } else {
      setLoading(false);
      return false;
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const locationGranted = await requestLocation();
      if (selectedChannelOption === "3") {
        if (locationGranted) {
          setDialogOpen(true);
        } else {
          alert("Location permission is required to proceed");
        }
      } else {
        await handleAddInteraction();
      }
    } catch (error) {
      alert("Location permission is required to proceed");
    }
  };

  const handleMobileViewClick = async (e) => {
    e.preventDefault();
    try {
      const locationGranted = await requestLocation();
      if (selectedChannelOption === "3") {
        if (locationGranted) {
          setISUploadScreen(true);
          setIsNextBtn(false);
        } else {
          alert("Location permission is required to proceed");
        }
      }
    } catch (error) {
      alert("Location permission is required to proceed");
    }
  };

  const handlePrepareQuote = () => {
    if (opportunityDetails?.productSubcategory === "Remittance") {
      navigate("/L2CreateRemittanceQuotation", {
        state: {
          contact_name: contactDetails?.contactPerson,
          contact_number: contactDetails?.contactNumber,
          contact_email: contactDetails?.contactEmail,
          product_id: productDetails?.id,
          product_name: productDetails?.name,
          product_category: productDetails?.subCategory,
          opportunity_id: param?.id as string,
          remarks: "",
          meeting_time: date,
          meetingStaff_id: selectedStaffOptions?.map((staff) =>
            Number(staff.value)
          ),
          note: interactionNote,
          channel_of_interaction_id: selectedChannelOption as string,
        },
      });
    }
    if (opportunityDetails?.productSubcategory === "Forex") {
      navigate("/createforexquotation", {
        state: {
          contact_name: contactDetails?.contactPerson,
          contact_number: contactDetails?.contactNumber,
          contact_email: contactDetails?.contactEmail,
          product_id: productDetails?.id,
          opportunity_id: param?.id as string,
          remarks: "",
          meeting_time: date,
          meetingStaff_id: selectedStaffOptions?.map((staff) =>
            Number(staff.value)
          ),
          note: interactionNote,
          channel_of_interaction_id: selectedChannelOption as string,
        },
      });
    }
    return;
  };

  async function handleRequestDoc() {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<RequestDocReqType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        opportunity_id: param?.id,
        exp_time: expires,
        channel,
        doc_list: selectedMode.map((mode) => ({ filename: mode })),
        note: popupnotes,
        channel_of_interaction_id: selectedChannelOption as string,
        interaction_note: interactionNote,
      },
    };

    try {
      const response = await requestDoc(req);
      if (response.status === 200) {
        toast.success("Documnet request sent successfully");
        setLoading(false);
        setInteractionNote("");
        setSelectedChannelOption("");
        setContactType("");
      }
    } catch (error) {
      toast.error("Unable to send document request");
      setLoading(false);
    }
  }

  const handleQuoteUploadVisa = async (file: File) => {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const base64 = await convertFileToBase64(file); // Await the base64 conversion

    const payload: AxiosRequestConfig<PostCorporateInteractionsReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        opportunity_id: param?.id as string,
        remarks: "",
        meeting_time: undefined,
        meetingStaff_id: [],
        note: interactionNote,
        channel_of_interaction_id: "9",
        quotation_pdf: "",
        geo_coordinates: {
          type: "point",
          data: {
            lng: location?.longitude as string,
            lat: location?.latitude as string,
          },
        },
        quotation_corporate: base64,
      },
    };

    try {
      const response = (await postCorporateInteractions(payload)) as any;
      if (response.status === 200) {
        toast.success("Quotation uploaded successfully");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Unable to upload quotation");
      setLoading(false);
    }
  };

  const buttonState = () => {
    if (!interactionNote || !selectedChannelOption) return false;
    if (selectedChannelOption === "3") {
      if (!meetingTime || !selectedContact || !selectedStaffOptions.length)
        return false;
    }
    return true;
  };

  const nextButtonState = () => {
    if (!interactionNote || !selectedChannelOption) return false;
    if (selectedChannelOption === "3") {
      if (!meetingTime || !selectedContact || !selectedStaffOptions.length)
        return false;
    }
    return true;
  };

  const changeLeadStatus = async ({ onSuccess }) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    try {
      const response = await axios.patch(
        "https://xxl6-bbr3-kxzs.m2.xano.io/api:rNhSdWJ8:UAT/editPartnerDetail",
        {
          partner_id: param?.id,
          lead_status: selectedLeadStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
            "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Lead Status Changed");
        await getOpportunity();
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to change the status";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const updateLeadStatus = async () => {
      if (selectedLeadStatus) {
        try {
          await changeLeadStatus({
            onSuccess: async () => {
              // Fetch the opportunity after successfully changing the lead status
              await getOpportunity();
            },
          });
        } catch (error) {
          console.error("Error in updating lead status:", error);
        }
      }
    };

    updateLeadStatus();
  }, [selectedLeadStatus]);

  useEffect(() => {
    const getLocation = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        setLocation({
          latitude: position?.coords?.latitude,
          longitude: position?.coords?.longitude,
        });
        setLoading(false);
        return true;
      } catch (error) {
        setLoading(false);
        return false;
      }
    };

    getLocation();
    getStaffs();
  }, []);

  return (
    <>
      {showConfirmation && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[50] h-screen w-[100vw] flex  w-full justify-center items-center"
        >
          <Confirm
            setShowConfirmation={setShowConfirmation}
            handleContinue={removeBankAccount}
            title={"Are you absolutely sure?"}
            message={`This action cannot be undone. Without a linked bank account, ${
              state?.name ? Capitalize(state?.name) : ""
            } will not be ready to receive commission payouts.`}
          />
        </div>
      )}

      {showGICModal && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[50] h-screen w-[100vw] flex justify-center items-center"
        >
          <EnableGIC
            setShowGICModal={setShowGICModal}
            channel_id={state?.id}
            PartnerDetails={PartnerDetails}
            setEnableGIC={setEnableGIC}
          />
        </div>
      )}

      {showAddProduct && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="bg-white-A700 fixed top-0 left-0 z-[50] h-screen w-[100vw] flex justify-center items-center"
        >
          <ProductActivation
            partner_id={state?.id}
            setShowAddProduct={setShowAddProduct}
            productOptionsList={productOptionsList}
            PartnerDetails={PartnerDetails}
          />
          ;
        </div>
      )}

      {showAddAccountModal && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[50] h-screen w-[100vw] flex justify-center items-center"
        >
          <AddBankAccountStep
            partnerId={state?.id}
            account_no={verifyBankAccount}
            setShowAddAccountModal={setShowAddAccountModal}
            setVerifyBankAccount={setVerifyBankAccount}
            PartnerDetails={PartnerDetails}
          />
        </div>
      )}

      {verifyBankAccount !== "" && !showAddAccountModal && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[50] h-screen w-[100vw] flex justify-center items-center"
        >
          <BankAccountVerification
            verifyBankAccount={verifyBankAccount}
            setVerifyBankAccount={setVerifyBankAccount}
            PartnerDetails={PartnerDetails}
          />
        </div>
      )}

      {showimg && (
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, .6)" }}
          className="fixed top-0 left-0 z-[50] h-screen w-[100vw] flex justify-center items-center"
        >
          {" "}
          <div className="relative bg-white-A700">
            <Img
              src={imgsrc}
              className="h-[300px] w-[500px] sm:w-[200px] sm:h-[200px]"
              alt="Loading...."
            />
            <div
              className="absolute top-[0] right-[-100px] "
              onClick={() => setShowimg(!showimg)}
            >
              <AiOutlineCloseCircle className="text-[30px] cursor-pointer" />
            </div>
          </div>
        </div>
      )}
      {/* </ReactModal> */}
      {loading && <Spinner />}
      <div className="flex flex-col h-screen gap-2.5 w-full overflow:hidden">
        <NavbarWithActions header={state?.name} />
        <div className="bg-white-A700 h-full overflow-y-auto overflow-x-hidden flex flex-1 flex-col flex-grow font-inter items-start justify-start w-full rounded-[12px] py-3">
          <div className="flex flex-col font-inter gap-8 items-start justify-center p-4 sm:p-2 rounded-[10px] w-full">
            <div className="flex justify-between items-start w-full">
              {isMobile ? (
                <>
                  <div className="flex flex-col gap-2 bg-white items-center p-4 ">
                    <h3 className="font-semibold leading-4 text-[16px] text-[#333333]">
                      Partner Details
                    </h3>

                    {(updatestatus !== "active" ||
                      updatestatus === "inactive") && (
                      <div
                        className={`h-[22px] px-2 py-[3px] gap-[10px] rounded-[6px] opacity-100 flex items-center justify-center ${
                          updatestatus === "inactive"
                            ? "bg-[#FFE5E5]"
                            : "bg-[#FFF7E2] w-[176px]"
                        }`}
                      >
                        <span
                          className={`h-[16px] opacity-100 font-inter text-[14px] font-medium leading-[16px] text-left ${
                            updatestatus === "inactive"
                              ? "text-[#FF4747]"
                              : "text-[#EAAF16]"
                          }`}
                        >
                          {updatestatus === "inactive"
                            ? "Partner is In-active"
                            : "Registration Incomplete"}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex flex-col gap-2">
                  <h3 className="font-semibold leading-4 text-lg text-black-label">
                    Partner Details
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className="font-normal leading-[22.4px] text-sm text-[#7E7E7E]">
                      Comprehensive details of
                    </span>
                    <span className="bg-[#F3F4F6] text-[#2B2B2B] px-2 py-0.5 rounded text-sm">
                      {id}
                    </span>
                    {(updatestatus !== "active" ||
                      updatestatus === "inactive") && (
                      <div
                        className={`h-[22px] px-2 py-[3px] gap-[10px] rounded-[6px] opacity-100 flex items-center justify-center ${
                          updatestatus === "inactive"
                            ? "bg-[#FFE5E5] w-auto"
                            : "bg-[#FFF7E2] w-[176px]"
                        }`}
                      >
                        <span
                          className={`h-[16px] opacity-100 font-inter text-[14px] font-medium leading-[16px] text-left ${
                            updatestatus === "inactive"
                              ? "text-[#FF4747] w-auto"
                              : "text-[#EAAF16] w-[160px]"
                          }`}
                        >
                          {updatestatus === "inactive"
                            ? "Partner is In-active"
                            : "Registration Incomplete"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Showing Status */}
              <div className="flex flex-row gap-[15px] items-center justify-end w-auto">
                <div className="flex flex-col items-center justify-end w-auto">
                  <div className="flex flex-row items-center gap-3 mt-2">
                    {updatestatus !== "incomplete" &&
                    updatestatus !== "pending" &&
                    updatestatus !== "" ? (
                      <SelectBox
                        className="bg-white-A700 border border-gray-200_01 border-solid font-medium p-1.5 rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px] w-[130px]"
                        placeholderClassName="text-blue_gray-700 text-[12px] w-[130px]"
                        isSearchable={true}
                        isMulti={false}
                        value={updatestatus}
                        onChange={(e) => {
                          setUpdatestatus(e);
                          handleonChangeStatus(e);
                        }}
                        indicator={
                          <>
                            <div
                              className={`${partnerbgColor} absolute top-[40%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                            ></div>
                            <svg
                              width="22"
                              height="23"
                              viewBox="0 0 22 23"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                id="Background"
                                cx="11"
                                cy="11.75"
                                r="11"
                                fill="#2B2B2B"
                                fillOpacity="0.1"
                              />
                              <image
                                href="/images/img_arrowdown.svg"
                                x="0"
                                y="0"
                                width="22"
                                height="23"
                              />
                            </svg>
                          </>
                        }
                        options={statusOptionsList}
                        name="status"
                      />
                    ) : (
                      <Button
                        onClick={resumeRegistration}
                        className="bg-blue-700 cursor-pointer h-auto py-2.5 rounded-md shadow-bs2 text-sm text-center text-white-A700 w-auto h-[40px] px-[10px]"
                      >
                        Resume Registration
                      </Button>
                    )}
                  </div>
                </div>
                <Button className="hidden cursor-pointer font-inter w-auto h-[40px] px-[10px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center text-[#252424]">
                  Reset Password
                </Button>
              </div>
            </div>

            <Tabs
              value={activeTab}
              onValueChange={onTabChange}
              className="w-full sm:overflow-hidden"
            >
              {isMobile ? (
                <Accordion
                  type="single"
                  collapsible
                  className="w-full"
                  value={isOpen ? "dropdown" : ""}
                  onValueChange={(val) => setIsOpen(val === "dropdown")}
                >
                  <AccordionItem value="dropdown">
                    <AccordionTrigger className="text-sm font-semibold px-4 py-2 bg-[#f1f5ff] rounded-lg text-blue-600 h-12">
                      {tabsdata.find((tab) => tab.value === activeTab)?.label ||
                        "Select Tab"}
                    </AccordionTrigger>

                    <AccordionContent className="bg-[#f1f5ff] rounded-lg px-4 py-2 space-y-2">
                      {tabsdata
                        .filter((tab) => tab.value !== activeTab)
                        .map((tab) => (
                          <div
                            key={tab.id + tab.value}
                            className="text-gray-700 hover:text-[#165FE3] cursor-pointer text-base font-semibold"
                            onClick={() => handleSelect(tab.value)}
                          >
                            {tab.label}
                          </div>
                        ))}
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              ) : (
                <TabsList className="border-b border-[#C4D7F9] w-full hide-scrollbar flex justify-between h-12 bg-navbar-menu-bg rounded-xl gap-2 py-2  overflow-x-auto">
                  {tabsdata?.map((tab) => {
                    return (
                      <TabsTrigger
                        key={tab.id}
                        value={tab.value}
                        onClick={() => setActiveTab(tab.value)}
                        className={`px-4 text-sm ${
                          tab?.value === activeTab &&
                          "border font-semibold border-blue-700 text-blue-700 w-[215px] rounded-lg shadow bg-white-A700"
                        }`}
                      >
                        {tab.label}
                      </TabsTrigger>
                    );
                  })}
                </TabsList>
              )}
              <TabsContent
                className="pb-0 px-3 sm:pt-1 sm:pb-0 sm:px-0 gap-5 sm:gap-6 flex flex-col rounded-xl w-full overflow-auto"
                value="overview"
              >
                <div className="bg-[#2B2B2B] text-white-A700 px-4 py-2 rounded-md inline-block w-fit text-base sm:text-sm">
                  <span className="font-medium">Partner ID : </span>
                  <span>{state?.id}</span>
                </div>

                <div className="bg-[#FFF5F5] p-4 sm:p-2 rounded-lg flex  flex-row sm:flex-col gap-4 justify-between items-center">
                  <div className="flex gap-3 items-center">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 11.9193V1.83594L18.3333 5.5026L11 9.16927"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18.8473 9.3726C19.3351 10.8761 19.3807 12.488 18.9788 14.0167C18.5768 15.5453 17.7442 16.9263 16.58 17.9954C15.4157 19.0645 13.9689 19.7766 12.4116 20.047C10.8543 20.3175 9.25206 20.1349 7.79555 19.5209C6.33904 18.907 5.08955 17.8876 4.19574 16.5839C3.30192 15.2803 2.80141 13.7474 2.75375 12.1675C2.70609 10.5876 3.11329 9.02722 3.92689 7.67208C4.7405 6.31695 5.92627 5.22406 7.34312 4.52344"
                        stroke="#333333"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p className="text-[#2B2B2B] text-[14px] sm:text-xs md:text-base">
                      This partner has been recently onboarded. Please check if
                      the partner has completed the initial onboarding steps and
                      take necessary steps in Onboarding details for smooth
                      onboarding.
                    </p>
                  </div>
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      <button className="bg-[#1A56DB] text-white-A700 px-4 sm:px-2 py-1 sm:py-2 rounded-md whitespace-nowrap text-sm sm:text-xs">
                        Check here
                      </button>
                    </AlertDialogTrigger>
                    <AlertDialogContent className="bg-white-A700 rounded-lg px-4 max-w-2xl animate-contentShow">
                      <AlertDialogHeader className="border-b text-left pb-4  -mx-4">
                        <AlertDialogTitle className="text-xl px-4 font-semibold">
                          Onboarding Checklist
                        </AlertDialogTitle>
                        <AlertDialogDescription className="font-medium px-4 text-base leading-6 tracking-[2%] text-[#7E7E7E] ">
                          Fill the required details
                        </AlertDialogDescription>
                      </AlertDialogHeader>

                      <div className="py-4">
                        <div className="flex flex-col w-full justify-start gap-[10px]">
                          {checkList.map((checkListItem) => (
                            <div
                              key={checkListItem.task}
                              className="flex flex-row w-full justify-start items-center pt-[5px] gap-[8px]"
                            >
                              <input
                                className="text-[#000000] accent-black bg-gray-100 border-[#000000] hover:border-[#000000] focus:border-[#000000] border border-[2px] "
                                checked={checkListItem.value}
                                onClick={() =>
                                  handleCheckBoxClick(checkListItem)
                                }
                                type="checkbox"
                              />
                              <Text
                                className="text-gray_900_01 text-sm w-full"
                                size="txtInterRegular14"
                              >
                                {checkListItem.task}
                              </Text>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AlertDialogFooter className="border-t pt-4">
                        <AlertDialogCancel
                          className=" m-0 rounded-lg border-blue-700 w-fit border py-[11px] px-4 text-white-A700 bg-blue-700"
                          asChild
                        >
                          <button>Close</button>
                        </AlertDialogCancel>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialog>
                </div>

                <div className="flex flex-row md:flex-col-reverse w-full gap-6 sm:gap-2">
                  {/* Left Column */}
                  <div className=" w-[493px] h-[136px] pt-5 flex flex-col sm:gap-2 gap-8 rounded-tl-[20px] opacity-100 bg-[#FCFCFC] sm:w-full">
                    <div className="w-[326px] h-[22px] items-center flex gap-5 opacity-100 sm:w-full md:w-[326px]">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-shrink-0"
                      >
                        <path
                          d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.22457 3.71649C6.76715 3.12836 6.05276 2.75 5.25 2.75C3.86929 2.75 2.75 3.86929 2.75 5.25C2.75 6.06385 3.13889 6.78687 3.74097 7.24337"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.7734 3.7195C17.2307 3.12966 17.9461 2.75 18.7503 2.75C20.131 2.75 21.2503 3.86929 21.2503 5.25C21.2503 6.06148 20.8637 6.78265 20.2646 7.23937"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12 8V12L9 15"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 21.25L7 20M18 21.25L17 20"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span
                        className="w-[120px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-base 
                        md:text-sm 
                        sm:w-auto 
                        md:w-[120px]"
                      >
                        Partner Contract :{" "}
                      </span>
                      <span
                        className="flex items-center justify-center w-auto h-[22px] px-3 py-1 gap-2 rounded-md border border-[#23AB28] font-inter text-sm font-medium opacity-100"
                        style={{ color: "#23AB28" }}
                      >
                        Signed
                      </span>
                      <a
                        href="#"
                        className="w-[95px] h-[20px] opacity-100 font-inter text-sm font-semibold leading-[19.6px] text-center text-[#165FE3] border-[#165FE3] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[95px]
                        hover:underline
                        flex items-center justify-center"
                      >
                        View contract
                      </a>
                    </div>

                    <div className="flex flex-col gap-2 pl-11 sm:pl-6 md:pl-11">
                      {/* Created by row */}
                      <div className="flex gap-2">
                        <span
                          className="w-[74px] h-[21px] font-inter text-sm font-medium text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[74px]"
                        >
                          Created by: {state?._created_byName}
                        </span>
                        <a
                          className="ml-[20px] font-inter text-sm font-medium text-[#165FE3]
                        sm:text-xs sm:w-auto
                        md:text-sm"
                        ></a>
                      </div>

                      {/* Created at row */}
                      <div className="flex gap-2">
                        <span
                          className="w-[74px] h-[21px] font-inter text-sm font-medium text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[74px]"
                        >
                          Created at:
                        </span>
                        <span
                          className="w-[74px] h-[21px] font-inter text-sm font-medium text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[74px]"
                        >
                          {formatUnixTimestamp(state?.created_at)}
                        </span>
                      </div>
                      <div className="flex gap-2">
                        <span
                          className="w-[140px] h-[21px] font-inter text-sm font-medium text-[#666666] whitespace-nowrap
                      sm:text-xs sm:w-auto
                      md:text-sm md:w-[140px]"
                        >
                          Relationship Manager: {state?._rm_name}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Partner Summary */}
                  <div className="w-[572px] md:w-full h-[349px] pt-5 sm:pt-0 gap-5 sm:gap-0 rounded-[20px] opacity-100 border sm:border-0 sm:border-[#D2D2DD] bg-white transition-all sm:w-full">
                    <div className="flex items-center gap-2 mb-4 px-6 sm:px-0 pt-5 sm:pt-0">
                      <div className="">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.25 21.25C7.04086 21.25 5.25 19.4591 5.25 17.25V6.75C5.25 4.54086 7.04086 2.75 9.25 2.75H16.25C18.4591 2.75 20.25 4.54086 20.25 6.75V17.25C20.25 19.4591 18.4591 21.25 16.25 21.25H9.25Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M12.75 11.5C13.8546 11.5 14.75 10.6046 14.75 9.5C14.75 8.39543 13.8546 7.5 12.75 7.5C11.6454 7.5 10.75 8.39543 10.75 9.5C10.75 10.6046 11.6454 11.5 12.75 11.5Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M9.25 16.5C9.25 14.8431 10.5931 13.5 12.25 13.5H13.25C14.9069 13.5 16.25 14.8431 16.25 16.5"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M3.75 8H6.75"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M3.75 12H6.75"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M3.75 16H6.75"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h3 className="text-lg sm:text-base sm:text-[#666666] font-medium w-[532px] h-[24px] opacity-100 flex items-center sm:items-start gap-3 sm:gap-1">
                        Partner Summary
                      </h3>
                    </div>

                    <div
                      className="w-[532px] h-[143px] pt-5 px-5 pb-5 gap-5 rounded-[20px] opacity-100 bg-[#FCFCFC] flex flex-col 
                      sm:w-full 
                      md:w-[532px] 
                      lg:w-[532px] 
                      xl:w-[532px]
                      sm:h-auto 
                      md:h-[143px]
                      sm:px-4
                      sm:gap-4
                      md:gap-5"
                    >
                      <div className="flex justify-between">
                        <span
                          className="w-[62px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[62px]"
                        >
                          Email ID :
                        </span>
                        <span
                          className="w-[202px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#333333] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[202px]"
                        >
                          {state?.email}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className="w-[62px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[62px]"
                        >
                          Organization Type :
                        </span>
                        <span
                          className="w-[202px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#333333] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[202px]"
                        >
                          {state?.pan_type}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className="w-[62px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[62px]"
                        >
                          Partner Trade :
                        </span>
                        <a
                          href="#"
                          className="w-[202px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#333333] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[202px]"
                        >
                          {state?.type}
                        </a>
                      </div>
                    </div>
                    <div
                      className="w-[532px] h-auto min-h-[102px] pt-5 sm:pt-1 px-5 pb-5 sm:pb-2 
                    flex flex-col gap-5 
                    rounded-tl-[20px] 
                    bg-[#FCFCFC]
                    opacity-100
                    sm:w-full 
                    md:w-[532px] 
                    lg:w-[532px] 
                    xl:w-[532px]
                    sm:px-4
                    sm:gap-2
                    md:gap-5"
                    >
                      <div className="flex justify-between">
                        <span
                          className="w-[62px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[62px]"
                        >
                          PAN Card :
                        </span>
                        <span
                          className="w-[202px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#333333] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[202px]"
                        >
                          <button
                            className="text-[#165FE3] font-medium text-sm hover:underline"
                            onClick={() => {
                              if (!state?.pan?.url) {
                                toast.error(" PAN Card not uploaded");
                              } else {
                                setImgsrc(state?.pan?.url);
                                setShowimg(true);
                              }
                            }}
                          >
                            View
                          </button>
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className="w-[62px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#666666] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[62px]"
                        >
                          Aadhar Card :
                        </span>
                        <a
                          href="#"
                          className="w-[202px] h-[21px] opacity-100 font-inter text-sm font-medium leading-[21px] text-left text-[#333333] whitespace-nowrap
                        sm:text-xs sm:w-auto
                        md:text-sm md:w-[202px]"
                        >
                          <button
                            className="text-[#165FE3] font-medium text-sm hover:underline"
                            onClick={() => {
                              if (state?.aadhar_front == null) {
                                toast.error("Aadhar Card not uploaded");
                              } else {
                                setImgsrc(state?.aadhar_front?.url);
                                setShowimg(true);
                              }
                            }}
                          >
                            View
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {
                  <div className="flex md:flex-col flex-row gap-5 sm:gap-0 w-full">
                    <div className="bg-white-A700 flex flex-1 flex-col gap-[20px] h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
                      <div className="flex flex-row w-full border-b border-gray-200 border-solid pb-2">
                        <Text
                          className="font-bold sm:pr-5 pr-[35px] pt-[3px] text-gray_900_01 text-sm uppercase w-full"
                          size="txtInterBold14"
                        >
                          Settings
                        </Text>
                      </div>
                      {true && (
                        <div className="pt-5 grid grid-cols-3 items-center gap-5">
                          <div className="flex gap-5">
                            <p className="">Redirect portal access</p>
                            <div className="flex flex-row gap-5 items-center justify-start">
                              <Switch.Root
                                className={`w-[45px] h-[25px] bg-blue_gray-lite-bg rounded-full  border-2 ${
                                  state?.canRedirect === "true"
                                    ? "border-green-500"
                                    : "border-red-600"
                                } outline-none cursor-default`}
                                id="airplane-mode"
                                style={{
                                  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                }}
                                checked={
                                  state?.canRedirect === "true" ? true : false
                                }
                                onCheckedChange={(checked) => {
                                  handleSettingsToggle();
                                }}
                              >
                                <Switch.Thumb
                                  className={`flex p-1 w-[20px] h-[20px] items-center ${
                                    state?.canRedirect === "true"
                                      ? "bg-green-400"
                                      : "bg-red-600"
                                  } rounded-full shadow-black-900 transition-transform duration-100 ${
                                    state?.canRedirect === "true" &&
                                    "translate-x-5"
                                  } will-change-transform`}
                                ></Switch.Thumb>
                              </Switch.Root>
                            </div>
                          </div>
                          {state?.canRedirect === "true" && (
                            <>
                              <div className="flex gap-5 items-center">
                                <p className="">Theme</p>
                                <div className="flex flex-row gap-5 items-center justify-start">
                                  <Select disabled>
                                    <SelectTrigger className="w-[180px]">
                                      <SelectValue placeholder="Select a theme" />
                                    </SelectTrigger>
                                    <SelectContent>
                                      <SelectGroup>
                                        <SelectLabel>Choose theme</SelectLabel>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="apple"
                                        >
                                          Blue
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="banana"
                                        >
                                          Orange
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="blueberry"
                                        >
                                          Green
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="grapes"
                                        >
                                          Red
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="pineapple"
                                        >
                                          Yellow
                                        </SelectItem>
                                      </SelectGroup>
                                    </SelectContent>
                                  </Select>
                                </div>
                              </div>
                              <div className="flex gap-5 items-center">
                                <p className="">Accent colour</p>
                                <div className="flex flex-row gap-5 items-center justify-start">
                                  <Select disabled>
                                    <SelectTrigger className="w-[180px]">
                                      <SelectValue placeholder="Select accent colour" />
                                    </SelectTrigger>
                                    <SelectContent>
                                      <SelectGroup>
                                        <SelectLabel>Choose theme</SelectLabel>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="apple"
                                        >
                                          Blue
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="banana"
                                        >
                                          Orange
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="blueberry"
                                        >
                                          Green
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="grapes"
                                        >
                                          Red
                                        </SelectItem>
                                        <SelectItem
                                          className="hover:bg-[#F3F8FF]"
                                          value="pineapple"
                                        >
                                          Yellow
                                        </SelectItem>
                                      </SelectGroup>
                                    </SelectContent>
                                  </Select>
                                </div>
                              </div>
                              <div className=" flex flex-col gap-2 w-full">
                                <h3 className="w-full">Upload/update logo</h3>
                                <div
                                  className={`py-1.5 px-3 justify-between border rounded-md flex ${
                                    file?.name && "bg-[#F2F7FF]"
                                  }`}
                                >
                                  <div className="flex gap-3 items-center overflow-hidden">
                                    <Img src="/images/remit/file.svg" alt="" />
                                    <p className="truncate text-[#999999] text-sm font-normal">
                                      {file?.name
                                        ? file?.name
                                        : "No file choosen"}
                                    </p>
                                  </div>
                                  <label
                                    htmlFor="payment_proof"
                                    className="text-blue-700 disabled:opacity-40 cursor-pointer border border-blue-700 text-white ml-2 px-4 py-1 rounded-lg whitespace-nowrap"
                                  >
                                    {file?.name ? "Re-upload" : "Upload"}
                                  </label>
                                  <input
                                    disabled
                                    name="payment_proof"
                                    type="file"
                                    id="payment_proof"
                                    className="hidden"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {state?.canRedirect === "true" && (
                        <div className="flex gap-5 items-center">
                          <AlertDialog>
                            <AlertDialogTrigger>
                              <button className="bg-blue-700 cursor-pointer py-2.5 rounded-md shadow-bs2  text-sm text-center text-white-A700 w-auto h-[40px] px-[10px]">
                                Generate link
                              </button>
                            </AlertDialogTrigger>
                            <AlertDialogPortal>
                              <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                              <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-xl animate-contentShow">
                                <AlertDialogHeader className="flex text-left bg-gray-button-gray-lite rounded-t-lg gap-4 p-0 ">
                                  <AlertDialogTitle className=" font-medium px-10 py-5 text-lg text-black-label">
                                    Generating Redirect Portal for {state?.name}
                                    <p className=" text-[#7E7E7E] text-sm font-medium">
                                      Wait for few seconds, if link is not
                                      visible{" "}
                                    </p>
                                  </AlertDialogTitle>
                                </AlertDialogHeader>
                                <div className="flex flex-col py-5 gap-5 px-10 ">
                                  <div className="flex items-center gap-3 px-3">
                                    <svg
                                      width="41"
                                      height="42"
                                      viewBox="0 0 41 42"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M20.5293 0.601562C9.28976 0.601562 0.130859 9.76046 0.130859 21C0.130859 32.2395 9.28976 41.3984 20.5293 41.3984C31.7688 41.3984 40.9277 32.2395 40.9277 21C40.9277 9.76046 31.7688 0.601562 20.5293 0.601562ZM30.2798 16.3084L18.7138 27.8743C18.4283 28.1599 18.0407 28.323 17.6327 28.323C17.2248 28.323 16.8372 28.1599 16.5516 27.8743L10.7788 22.1015C10.1873 21.51 10.1873 20.5308 10.7788 19.9393C11.3704 19.3477 12.3495 19.3477 12.9411 19.9393L17.6327 24.6309L28.1175 14.1461C28.7091 13.5546 29.6882 13.5546 30.2798 14.1461C30.8713 14.7377 30.8713 15.6964 30.2798 16.3084Z"
                                        fill="#3FB73D"
                                      />
                                    </svg>
                                    <p className="text-sm font-semibold text-[#3FB73D]">
                                      URL Generated Successfully
                                    </p>
                                  </div>
                                  <div className="flex flex-col gap-4 p-4 bg-[#FBFCFF] rounded-xl">
                                    <div className="flex border flex-col border-blue-700 rounded-lg gap-3 p-3">
                                      <div className="flex gap-2 text-sm text-[#2D3648] font-medium">
                                        <p className="text-sm">Create URL</p>
                                        <svg
                                          className=" cursor-pointer"
                                          onClick={() =>
                                            navigator.clipboard.writeText(
                                              `https://maxx.moneeflo.com/redirect?partner_id=${state?.unique_id}`
                                            )
                                          }
                                          width="19"
                                          height="19"
                                          viewBox="0 0 19 19"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.6309 3.21094H9.13086C8.68331 3.21094 8.25408 3.38873 7.93762 3.70519C7.62115 4.02166 7.44336 4.45088 7.44336 4.89844V6.02344H9.13086C10.026 6.02344 10.8844 6.37902 11.5173 7.01195C12.1503 7.64489 12.5059 8.50333 12.5059 9.39844V11.0859H13.6309C14.0784 11.0859 14.5076 10.9081 14.8241 10.5917C15.1406 10.2752 15.3184 9.84599 15.3184 9.39844V4.89844C15.3184 4.45088 15.1406 4.02166 14.8241 3.70519C14.5076 3.38873 14.0784 3.21094 13.6309 3.21094ZM12.5059 12.7734H13.6309C14.526 12.7734 15.3844 12.4179 16.0173 11.7849C16.6503 11.152 17.0059 10.2935 17.0059 9.39844V4.89844C17.0059 4.00333 16.6503 3.14489 16.0173 2.51195C15.3844 1.87902 14.526 1.52344 13.6309 1.52344H9.13086C8.23575 1.52344 7.37731 1.87902 6.74437 2.51195C6.11144 3.14489 5.75586 4.00333 5.75586 4.89844V6.02344H4.63086C3.73575 6.02344 2.87731 6.37902 2.24437 7.01195C1.61144 7.64489 1.25586 8.50333 1.25586 9.39844V13.8984C1.25586 14.7935 1.61144 15.652 2.24437 16.2849C2.87731 16.9179 3.73575 17.2734 4.63086 17.2734H9.13086C10.026 17.2734 10.8844 16.9179 11.5173 16.2849C12.1503 15.652 12.5059 14.7935 12.5059 13.8984V12.7734ZM4.63086 7.71094H9.13086C9.57841 7.71094 10.0076 7.88873 10.3241 8.20519C10.6406 8.52166 10.8184 8.95088 10.8184 9.39844V13.8984C10.8184 14.346 10.6406 14.7752 10.3241 15.0917C10.0076 15.4081 9.57841 15.5859 9.13086 15.5859H4.63086C4.18331 15.5859 3.75408 15.4081 3.43762 15.0917C3.12115 14.7752 2.94336 14.346 2.94336 13.8984V9.39844C2.94336 8.95088 3.12115 8.52166 3.43762 8.20519C3.75408 7.88873 4.18331 7.71094 4.63086 7.71094Z"
                                            fill="#2D3648"
                                          />
                                        </svg>
                                      </div>
                                      <p className="text-base text-blue-700 font-medium">{`https://maxx.moneeflo.com/redirect?partner_id=${state?.unique_id}`}</p>
                                    </div>
                                    <div className="flex border flex-col border-blue-700 rounded-lg gap-3 p-3">
                                      <div className="flex gap-2 text-sm text-[#2D3648] font-medium">
                                        <p className="text-sm">Track order</p>
                                        <svg
                                          className=" cursor-pointer"
                                          onClick={() =>
                                            navigator.clipboard.writeText(
                                              `https://maxx.moneeflo.com/redirect/track?partner_id=${state?.id}`
                                            )
                                          }
                                          width="19"
                                          height="19"
                                          viewBox="0 0 19 19"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.6309 3.21094H9.13086C8.68331 3.21094 8.25408 3.38873 7.93762 3.70519C7.62115 4.02166 7.44336 4.45088 7.44336 4.89844V6.02344H9.13086C10.026 6.02344 10.8844 6.37902 11.5173 7.01195C12.1503 7.64489 12.5059 8.50333 12.5059 9.39844V11.0859H13.6309C14.0784 11.0859 14.5076 10.9081 14.8241 10.5917C15.1406 10.2752 15.3184 9.84599 15.3184 9.39844V4.89844C15.3184 4.45088 15.1406 4.02166 14.8241 3.70519C14.5076 3.38873 14.0784 3.21094 13.6309 3.21094ZM12.5059 12.7734H13.6309C14.526 12.7734 15.3844 12.4179 16.0173 11.7849C16.6503 11.152 17.0059 10.2935 17.0059 9.39844V4.89844C17.0059 4.00333 16.6503 3.14489 16.0173 2.51195C15.3844 1.87902 14.526 1.52344 13.6309 1.52344H9.13086C8.23575 1.52344 7.37731 1.87902 6.74437 2.51195C6.11144 3.14489 5.75586 4.00333 5.75586 4.89844V6.02344H4.63086C3.73575 6.02344 2.87731 6.37902 2.24437 7.01195C1.61144 7.64489 1.25586 8.50333 1.25586 9.39844V13.8984C1.25586 14.7935 1.61144 15.652 2.24437 16.2849C2.87731 16.9179 3.73575 17.2734 4.63086 17.2734H9.13086C10.026 17.2734 10.8844 16.9179 11.5173 16.2849C12.1503 15.652 12.5059 14.7935 12.5059 13.8984V12.7734ZM4.63086 7.71094H9.13086C9.57841 7.71094 10.0076 7.88873 10.3241 8.20519C10.6406 8.52166 10.8184 8.95088 10.8184 9.39844V13.8984C10.8184 14.346 10.6406 14.7752 10.3241 15.0917C10.0076 15.4081 9.57841 15.5859 9.13086 15.5859H4.63086C4.18331 15.5859 3.75408 15.4081 3.43762 15.0917C3.12115 14.7752 2.94336 14.346 2.94336 13.8984V9.39844C2.94336 8.95088 3.12115 8.52166 3.43762 8.20519C3.75408 7.88873 4.18331 7.71094 4.63086 7.71094Z"
                                            fill="#2D3648"
                                          />
                                        </svg>
                                      </div>
                                      <p className="text-base text-blue-700 font-medium">{`https://maxx.moneeflo.com/redirect/track?partner_id=${state?.id}`}</p>
                                    </div>
                                  </div>
                                  <div className=""></div>
                                </div>
                                <AlertDialogFooter className="flex items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                  <AlertDialogCancel
                                    className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                                    asChild
                                  >
                                    <button className="" onClick={() => {}}>
                                      Continue
                                    </button>
                                  </AlertDialogCancel>
                                </AlertDialogFooter>
                              </AlertDialogContent>
                            </AlertDialogPortal>
                          </AlertDialog>
                        </div>
                      )}
                    </div>
                  </div>
                }
              </TabsContent>
              <TabsContent
                className="pb-0 px-3 sm:pt-1 sm:pb-0 sm:px-0 gap-5 flex flex-col rounded-xl w-full overflow-auto"
                value="interaction"
              >
                {isMobile ? (
                  <ForexOrderInteractionCard
                    columns={InteractionColumn}
                    data={interactionList}
                    onRowClick={() => {}}
                    isPaginationVisible={interactionList?.length > 10}
                    defaultSorting={[{ id: "createdAt", desc: true }]}
                    isPageCountVisible={interactionList?.length > 10}
                  />
                ) : (
                  <div className="flex gap-0 flex-col ">
                    <DataTable
                      columns={InteractionColumn}
                      data={interactionList}
                      isToolbarVisible={false}
                      isPaginationVisible={interactionList.length > 10}
                      defaultSorting={[{ id: "createdAt", desc: true }]}
                      isPageCountVisible={interactionList.length > 10}
                    />
                  </div>
                )}
              </TabsContent>
              <TabsContent
                className="pt-2 pb-0 px-3 sm:pt-1 sm:pb-0 sm:px-0 gap-5 flex flex-col rounded-xl w-full overflow-auto"
                value="products"
              >
                <div className="flex w-full justify-between items-center">
                  <h3
                    className="text-[#333333] font-bold leading-4 tracking-[0.02em] text-lg sm:text-sm"
                    style={{
                      marginLeft: "14px",
                      width: "157px",
                      height: "16px",
                      gap: "0px",
                      opacity: "1px",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      lineHeight: "16px",
                    }}
                  >
                    Set Commissions
                  </h3>
                  <div className="flex justify-end">
                    {!["incomplete", "pending"].includes(updatestatus) && (
                      <button
                        className="rounded-lg py-[10px] sm:py-[8px] px-2 bg-blue-700 text-white-A700 font-semibold text-sm whitespace-nowrap min-w-max"
                        onClick={() => setDialogOpen(true)}
                      >
                        Add or Edit Product
                      </button>
                    )}
                    <div>
                      {dialogOpen && (
                        <Product
                          dialogOpen={dialogOpen}
                          setDialogOpen={setDialogOpen}
                          channel_commission={state._channel_commission}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex items-start flex-col justify-between  p-4 sm:p-0 rounded-lg w-full gap-5 opacity-1">
                  <p className="text-sm text-[#333333] font-medium ">
                    Select the Product Commission for
                  </p>

                  {productOptionsList.map((product) => (
                    <div
                      key={product.id}
                      className="flex flex-col w-full gap-2"
                    >
                      <div
                        className={`flex items-center px-4 py-2.5 gap-5 rounded-lg cursor-pointer transition-all ${
                          toggledProduct === product.id
                            ? "bg-[#F6F9FF] border-[1px] border-[#165FE3] h-[46px] rounded-tl-[6px]"
                            : "bg-[#F9F9F9] border-[1px] border-[#333333]"
                        }`}
                        onClick={() =>
                          setToggledProduct(
                            toggledProduct === product.id ? null : product.id
                          )
                        }
                      >
                        <span
                          className={`text-base transition-all ${
                            toggledProduct === product.id
                              ? "text-[#165FE3] font-medium text-[14px] leading-[16px] tracking-[-0.01em] w-[26px] h-[16px]"
                              : "text-[#2B2B2B]"
                          }`}
                        >
                          {product?.label}
                        </span>

                        {/* Toggle Switch */}
                        <div className="flex items-center  ">
                          <div
                            className={`relative flex items-center justify-center w-[24px] h-[13.63px] rounded-full transition-all ${
                              toggledProduct === product.id
                                ? "bg-[#165FE3]"
                                : "bg-[#D2D2D2]"
                            }`}
                          >
                            <div
                              className={`absolute w-[9.38px] h-[9.38px] rounded-full transition-all ${
                                toggledProduct === product.id
                                  ? "bg-[#FFFFFF] left-[13.09px] top-[2.13px]"
                                  : "bg-[#4A4A4A] left-[2.18px] top-[2.13px]"
                              }`}
                            ></div>
                          </div>
                        </div>
                      </div>

                      {toggledProduct === product.id && (
                        <div className="w-full pt-5 pb-5">
                          <CommissionRateTable
                            isUpdate={true}
                            commissionRates={commisionrate}
                            id={1}
                            UpdateCommisionRate={[
                              { commision_rates_id: "", charges: 0 },
                            ]}
                            setUpdateCommisionRate={() => {}}
                          />
                        </div>
                      )}
                    </div>
                  ))}

                  {/* Add Product Section */}

                  {/* <div className="bg-white-A700 flex flex-col font-inter gap-2.5 items-start justify-center md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
            <div className="flex flex-row w-full h-[36px]">
               <Text className="font-rubik text-md md:text-[22px]  sm:text-xl font-bold uppercase w-full pb-[10px]">
                 Products
               </Text>
               <div className="flex flex-row items-center gap-[10px] justify-end w-auto">
                 {productOptionsList && productOptionsList.length > 0 && (
                  <SelectBox
                    className="bg-white-A700 border border-gray-200_01 border-solid font-medium p-1.5 rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px] w-[160px]"
                    placeholderClassName="text-blue_gray-700 text-[12px] w-[130px]"
                    isSearchable={true}
                    isMulti={false}
                    value={product}
                    onChange={(e) => {
                      setProduct(e);
                      setProductStatus(
                        productOptionsList.find((item: any) => item.value === e)
                          ?.status,
                      );
                    }}
                    indicator={
                      <>
                        <div
                          className={`${partnerbgColor} absolute top-[40%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                        ></div>
                        <svg
                          width="22"
                          height="23"
                          viewBox="0 0 22 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            id="Background"
                            cx="11"
                            cy="11.75"
                            r="11"
                            fill="#2B2B2B"
                            fillOpacity="0.1"
                          />
                          <image
                            href="/images/img_arrowdown.svg"
                            x="0"
                            y="0"
                            width="22"
                            height="23"
                          />
                        </svg>
                      </>
                    }
                    options={productOptionsList}
                    name="status"
                  />
                )}

                <Button
                  className="cursor-pointer bg-blue-700 text-white-A700 font-inter w-[150px] h-auto px-[20px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center"
                  onClick={() => {
                    setShowAddProduct(true);
                  }}
                >
                  + Add Product
                </Button>
              </div>
            </div>
            {commisionratedata && commisionratedata.length > 0 && (
              <>
                <Text className="text-[#797D8C] border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                  Commission Rate
                </Text>
                <div className="flex flex-col overflow-auto bg-white-A700 border border-indigo-50_01 border-solid font-rubik rounded w-full">
                  <ReactTable
                    columns={CommisionTableColumn}
                    data={commisionratedata}
                    headerClass="bg-[#E7E7ED]"
                  />
                </div>
              </>
            )}
            {productStatus && productStatus !== "approved" && (
              <div className="flex flex-row justify-end overflow-auto bg-white-A700  font-rubik rounded w-full">
                <Button
                  onClick={() => postapprovalcommision(updatecommisionratedata)}
                  className="float-right bg-blue-700 cursor-pointer font-inter w-[193px] ml-10 py-2.5 rounded-md shadow-bs2 text-base text-center text-white-A700"
                >
                  Approved Margin
                </Button>
              </div>
            )}
          </div> */}

                  {/* Back button */}
                  <div className="mt-4">
                    <button
                      onClick={() => navigate("/partners")}
                      className="text-blue-700 font-medium text-sm hover:underline"
                    >
                      Back to Partners
                    </button>
                  </div>
                </div>
              </TabsContent>

              <TabsContent
                className="pt-2 pb-0 px-3 sm:pt-1 sm:pb-0 sm:px-0 gap-5 flex flex-col rounded-xl w-full overflow-auto"
                value="bank-accounts-details"
              >
                <div className="flex flex-col gap-6">
                  {/* Header */}
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col gap-2">
                      <h3 className="font-semibold text-lg sm:text-sm text-black-label">
                        Bank Account Details
                      </h3>
                      <p className="font-normal text-sm sm:text-xs text-[#7E7E7E]">
                        Manage bank accounts for {state?.name}
                      </p>
                    </div>
                    <Button
                      className="rounded-lg py-[10px] sm:py-[8px] px-2 bg-blue-700 text-white-A700 font-semibold text-sm whitespace-nowrap min-w-max"
                      onClick={() => {
                        setVerifyBankAccount("");
                        setShowAddAccountModal(true);
                      }}
                    >
                      Link Bank Account
                    </Button>
                  </div>

                  {/* Bank Accounts List */}
                  <div className="flex flex-col gap-4">
                    {bankAccounts.length > 0 ? (
                      bankAccounts.map((bank) => {
                        let bankbgColor;
                        switch (bank.status) {
                          case "active":
                            bankbgColor = "bg-[#008000]";
                            break;
                          case "inactive":
                            bankbgColor = "bg-[#FFA500]";
                            break;
                          case "unverified":
                            bankbgColor = "bg-[#FFA500]";
                            break;
                          case "incomplete":
                            bankbgColor = "bg-[#008000]";
                            break;
                        }

                        return (
                          <div
                            key={bank.id}
                            className="border border-gray-200 rounded-lg p-5"
                          >
                            {/* Bank Header */}
                            <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                              <div className="flex items-center gap-3">
                                <span className="font-medium">
                                  {bank.bank_name}
                                </span>
                                {bank.primary_account && (
                                  <span className="text-sm text-blue-700">
                                    Primary Bank
                                  </span>
                                )}
                              </div>

                              <div className="flex items-center gap-4">
                                <div className="relative">
                                  <SelectBox
                                    className="bg-white-A700 border border-gray-200 rounded-lg text-sm pl-3 pr-3 py-1.5 w-36"
                                    value={bank.status}
                                    isDisabled={true}
                                    options={bankStatusOptionsList}
                                  />
                                </div>

                                <div className="relative">
                                  <Button
                                    className="p-2"
                                    onClick={() =>
                                      setEditBankRow(
                                        editBankRow === bank.id ? "" : bank.id
                                      )
                                    }
                                  >
                                    <Img
                                      src="/images/img_ellipses.svg"
                                      alt="options"
                                    />
                                  </Button>
                                  {editBankRow === bank.id && (
                                    <div className="absolute top-full right-0 mt-1 bg-white shadow-lg rounded-md border border-gray-200 py-1">
                                      <button
                                        className="w-full px-4 py-2 text-red-500 text-sm hover:bg-gray-50 flex items-center gap-2"
                                        onClick={() =>
                                          setShowConfirmation(true)
                                        }
                                      >
                                        <span>Remove</span>
                                        <Img
                                          width={12}
                                          height={12}
                                          src={deleteSvg2}
                                          alt="delete"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Bank Details */}
                            <div
                              className={`mt-4 ${
                                bank.status === "incomplete" ||
                                bank.status === "unverified"
                                  ? "opacity-20"
                                  : ""
                              }`}
                            >
                              <div className="flex justify-between py-1">
                                <span className="text-gray-500">
                                  Bank Account number
                                </span>
                                <span className="text-blue-700">
                                  {bank.account_number}
                                </span>
                              </div>
                              <div className="flex justify-between py-1">
                                <span className="text-gray-500">IFSC Code</span>
                                <span className="text-blue-700">
                                  {bank.ifsc_code}
                                </span>
                              </div>
                            </div>

                            {/* Verification Notice */}
                            {(bank.status === "unverified" ||
                              bank.status === "incomplete") && (
                              <div className="mt-4 flex items-center gap-3 justify-center">
                                <div className="bg-blue-50 p-1.5 rounded">
                                  <Img
                                    src="/images/img_tick.svg"
                                    alt="verify"
                                    className="w-5 h-5"
                                  />
                                </div>
                                <span>Verify your Bank Account</span>
                                {bank.status === "unverified" && (
                                  <button
                                    className="text-blue-700 hover:underline"
                                    onClick={() =>
                                      setVerifyBankAccount(bank.id)
                                    }
                                  >
                                    Click Here
                                  </button>
                                )}
                                {bank.status === "incomplete" && (
                                  <button
                                    className="text-blue-700 text-sm hover:underline"
                                    onClick={() => {
                                      setVerifyBankAccount(bank.id);
                                      setShowAddAccountModal(true);
                                    }}
                                  >
                                    Reupload the document
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div className="border border-gray-200 rounded-lg p-8 text-center">
                        <div className="flex flex-col items-center gap-4">
                          <div className="bg-blue-50 p-3 rounded-lg">
                            <Img
                              src="/images/img_link.svg"
                              alt="link"
                              className="w-8 h-8"
                            />
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            <p className="font-medium text-gray-900">
                              No Bank Account is Linked
                            </p>
                            <p className="font-normal text-sm text-[#7E7E7E]">
                              Please add a bank account to proceed.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </TabsContent>
              <TabsContent
                className="pt-2 pb-0 px-3 sm:pt-1 sm:pb-0 sm:px-0 gap-3 flex flex-col rounded-xl w-full overflow-auto"
                value="other-details"
              >
                <div className="flex justify-end sm:justify-start">
                  <div>
                    <button
                      className="rounded-lg py-[10px] px-2 bg-blue-700 text-white-A700 font-semibold text-sm"
                      onClick={() => setDialogOpen(true)}
                    >
                      Add or Edit Product
                    </button>
                    <AlertDialog
                      open={dialogOpen}
                      onOpenChange={(val) => {
                        if (!val) {
                          handleClose();
                        }
                        handleDialogOpen(val);
                      }}
                    >
                      <AlertDialogTrigger></AlertDialogTrigger>

                      <AlertDialogPortal>
                        <AlertDialogOverlay className="bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />

                        <AlertDialogContent className="bg-white-A700 flex flex-col rounded-lg p-0 h-[80vh] sm:h-[90vh] max-w-2xl animate-contentShow">
                          {/* Dialog Header */}
                          <AlertDialogHeader className="text-left border-b rounded-t h-min py-5 px-10 gap-0">
                            <AlertDialogTitle className="font-bold p-0 text-lg text-black-label">
                              Add or Edit Product
                            </AlertDialogTitle>
                          </AlertDialogHeader>

                          {/* Blank Body */}
                          <div className="bg-[#EBEEF5] p-[10px] h-full overflow-auto">
                            <div className="bg-[#ffffff] h-full overflow-auto p-[10px] text-gray-400 rounded-lg">
                              {/* You can add your form or other content here later */}
                              <div className="w-full">
                                <Product />
                              </div>
                            </div>
                          </div>

                          {/* Footer (optional) */}
                          <AlertDialogFooter className="flex justify-start sm:justify-start h-min items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                            <AlertDialogCancel asChild>
                              <button className="m-0 h-full rounded-lg text-sm font-semibold border-blue-700 border py-[11px] px-4 text-blue-700">
                                Close
                              </button>
                            </AlertDialogCancel>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialogPortal>
                    </AlertDialog>
                  </div>
                </div>
                <div className="w-full flex flex-row sm:flex-col gap-8">
                  {/* Left Div */}
                  <div className="w-full flex flex-col">
                    <h3 className="w-[172px] h-[19px] text-base font-medium text-[#999999] mb-4">
                      Partner Branch Details
                    </h3>
                    <div
                      className="w-full h-auto p-5 rounded-xl border border-white shadow-md"
                      style={{
                        boxShadow: "1px 1px 7px 0px #2252A71A",
                        background: "#FFFFFF",
                      }}
                    >
                      <div className="flex flex-col space-y-3">
                        <div className="flex justify-between">
                          <span className="text-sm">Address Line 1:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.address_line_1}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Address Line 2:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.address_line_2}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">City:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.city}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">State:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.state}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Pincode:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.pincode}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Div */}
                  <div className="w-full flex flex-col">
                    <h3 className="w-[115px] h-[19px] text-base font-medium text-[#999999] mb-4">
                      Office Address
                    </h3>
                    <div
                      className="w-full h-auto p-5 rounded-xl border border-white shadow-md"
                      style={{
                        boxShadow: "1px 1px 7px 0px #2252A71A",
                        background: "#FFFFFF",
                      }}
                    >
                      <div className="flex flex-col space-y-3">
                        <div className="flex justify-between">
                          <span className="text-sm">Address Line 1:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.address_line_1}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Address Line 2:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.address_line_2}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">City:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.city}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">State:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.state}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-sm">Pincode:</span>
                          <span className="font-medium text-base sm:text-xs">
                            {state?.pincode}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabsContent>
            </Tabs>
          </div>
          {isMobile ? (
            <Sheet
              open={isInteractionModal}
              onOpenChange={setIsInteractionModal}
            >
              <SheetTrigger asChild>
                <div
                  className="relative"
                  onClick={() => setIsInteractionModal(true)}
                >
                  <button className="" />
                  <div className="fixed bottom-0 left-0 right-0 mx-2 z-50 transition-all duration-300 ease-out bg-white shadow-lg rounded-t-2xl">
                    <button className="cursor-pointer w-full flex items-center justify-center h-12 bg-white-A700 border-t border-blue-700 rounded-t-2xl">
                      <span className="text-blue-700 text-sm font-semibold">
                        + Add Interaction
                      </span>
                    </button>
                  </div>
                </div>
              </SheetTrigger>
              <SheetOverlay />
              <SheetContent
                className="bg-white-A700 px-2 pt-3 pb-5 h-auto"
                side="bottom"
              >
                <div className=" bg-white z-70 relative rounded-t-2xl bg-white-A700">
                  <div className="flex w-full items-center justify-center pb-[18px]">
                    <div className="flex relative items-center justify-center w-full ">
                      <p className="text-base text-blue-700 font-bold ">
                        + Add Interaction
                      </p>
                      {/* <Popover>
                        {opportunityDetails?.productSubcategory !==
                          "Remittance" && (
                          <PopoverTrigger className="absolute right-0">
                            <svg
                              width="8"
                              height="22"
                              viewBox="0 0 8 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.03125 10.0156H3.02139V10.0256H3.03125V10.0156ZM3.03125 3.01562H3.02139V3.02563H3.03125V3.01562ZM3.03125 17.0156H3.02139V17.0256H3.03125V17.0156Z"
                                fill="black"
                                stroke="#292929"
                                stroke-width="4.36364"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </PopoverTrigger>
                        )}
                        <PopoverContent className="py-1">
                          <div className="col-span-2">
                            {pipelineType === "retail" &&
                              opportunityDetails?.productSubcategory !==
                                "Remittance" && (
                                <DocPopup
                                  buttonName="Collect Documents"
                                  buttonState={buttonState}
                                  onSubmit={handleRequestDoc}
                                  selectedMode={selectedMode}
                                  setSelectedMode={setSelectedMode}
                                  expires={expires}
                                  setExpires={setExpires}
                                  popupnotes={popupnotes}
                                  setPopupNotes={setPopupNotes}
                                  channel={channel}
                                  setChannel={setChannel}
                                  className="bg-white-A700 text-[#000000]"
                                />
                              )}
                          </div>
                        </PopoverContent>
                      </Popover> */}
                    </div>
                  </div>
                  {isUploadScreen ? (
                    <>
                      <div className="p-4 w-full bg-white">
                        <p className="text-base font-medium text-[#333333] mb-4">
                          Click/upload a photo covering yourself and partner’s
                          office.
                        </p>

                        <div className="flex justify-center mb-5">
                          <img
                            className="w-[171px] h-[98.31px] rounded-[5.54px] border border-gray-300 object-cover"
                            src={
                              previewUrl ||
                              (methods2.getValues("office_photo") &&
                              typeof methods2.getValues("office_photo") ===
                                "string" &&
                              methods2.getValues("office_photo") !==
                                "data:application/octet-stream;base64,"
                                ? methods2.getValues("office_photo")
                                : "/images/Selfie.png")
                            }
                            alt="Office photo preview"
                          />
                        </div>

                        <div className="flex justify-center mb-5">
                          <label className="cursor-pointer">
                            <input
                              id="photo_upload_input"
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={(e) => {
                                if (e.target.files?.[0]) {
                                  handleMobileFileChange(e.target.files[0]);
                                }
                              }}
                            />
                            <div className="h-12 flex items-center justify-center px-4 py-2.5 font-semibold text-sm text-[#165FE3] bg-white border border-blue-600 rounded-lg shadow-sm transition-colors hover:bg-blue-50 max-w-[150px] w-full">
                              {methods2.getValues("office_photo")
                                ? "Re-upload"
                                : "Upload Photo"}
                            </div>
                          </label>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* {textarea condition} */}
                      <div className="mb-4">
                        <textarea
                          onChange={(e) => {
                            setInteractionNote(e.target.value);
                          }}
                          value={interactionNote}
                          className="w-full p-3 border border-black-200 rounded-xl text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                          placeholder="Write your notes here..."
                          rows={3}
                          style={{ resize: "none" }}
                        />
                      </div>

                      {/* below condition */}
                      <div className="grid grid-cols-2 gap-3 mb-4">
                        <Select
                          disabled={selectedType === "outbound"}
                          onValueChange={(val) => {
                            setSelectedType("inbound");
                            setSelectedChannelOption(val);
                            if (val === "3") {
                              setIsNextBtn(true);
                            }
                          }}
                          value={
                            selectedType === "inbound"
                              ? selectedChannelOption
                              : ""
                          }
                        >
                          <SelectTrigger
                            hideIcon
                            className={`${
                              selectedType === "outbound"
                                ? "hidden"
                                : selectedType !== ""
                                ? "col-span-2"
                                : ""
                            } bg-[#E1EBFC] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap relative`}
                          >
                            <div className="flex gap-3 items-center">
                              <SelectValue placeholder="I contacted" />
                              {!selectedChannelOption && (
                                <ChevronDown className="h-4 w-4 text-blue-600 ml-10 pointer-events-none" />
                              )}
                            </div>
                            {selectedChannelOption && (
                              <X
                                className="h-4 w-4 z-50 text-blue-600 ml-2 cursor-pointer border border-blue-700 rounded-full"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setSelectedType("");
                                  setSelectedChannelOption("");
                                  setIsNextBtn(false);
                                }}
                              />
                            )}
                          </SelectTrigger>
                          {selectedChannelOption &&
                            selectedChannelOption === "3" && (
                              <div
                                className={
                                  "col-span-2 border-none bg-[#fff] h-auto mb-2"
                                }
                              >
                                <div className="flex flex-col gap-2">
                                  <div className="">
                                    <form className="w-full" action="">
                                      <label
                                        htmlFor="ll"
                                        className="font-medium text-sm items-start justify-start whitespace-nowrap leading-[18.2px] text-[#333333]"
                                      >
                                        Search & add team members
                                      </label>
                                      <ReactSelect
                                        closeMenuOnSelect={false}
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,
                                            zIndex: 0,
                                            borderRadius: ".5rem",
                                            padding: ".3rem",
                                            borderColor: state.isFocused
                                              ? "#165FE3"
                                              : "#333333",
                                            boxShadow: "none",
                                            width: "100%",
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 1000,
                                            width: "100%",
                                          }),
                                          container: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }),
                                        }}
                                        components={{
                                          DropdownIndicator: () => (
                                            <div className="pr-1">
                                              <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clipPath="url(#clip0_2821_158352)">
                                                  <path
                                                    d="M10.0991 18.6318L10.0988 18.6318C9.94355 18.6313 9.79483 18.5695 9.68508 18.4597C9.57533 18.35 9.51347 18.2012 9.51301 18.046L9.513 18.0456L9.51149 10.59L2.05583 10.5884L2.04426 10.5884L2.04429 10.588C1.89676 10.5766 1.75897 10.5099 1.65846 10.4013C1.55795 10.2927 1.50211 10.1502 1.50211 10.0022C1.50211 9.85428 1.55795 9.71176 1.65846 9.60317C1.75897 9.49457 1.89676 9.42791 2.04429 9.4165L2.05583 9.4156L2.05583 9.41605L9.51143 9.41453L9.50991 1.95893L9.50992 1.9589C9.50992 1.80302 9.57184 1.65353 9.68206 1.54331C9.79228 1.43308 9.94178 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116L10.0977 1.52072L10.0977 1.37116M10.0991 18.6318C10.1763 18.6318 10.2528 18.6167 10.3241 18.5871L10.2669 18.4489L10.3241 18.5871C10.3955 18.5576 10.4603 18.5143 10.5149 18.4597C10.5695 18.4051 10.6128 18.3403 10.6423 18.269L10.5037 18.2116L10.6423 18.269C10.6718 18.1976 10.687 18.1212 10.6869 18.044L10.6869 10.59L18.1425 10.5884C18.1426 10.5884 18.1426 10.5884 18.1426 10.5884C18.2984 10.5884 18.4479 10.5265 18.5581 10.4163C18.6684 10.3061 18.7303 10.1566 18.7303 10.0007C18.7303 9.84482 18.6684 9.69532 18.5581 9.5851C18.4479 9.47488 18.2984 9.41295 18.1425 9.41295L18.1425 9.41295L10.6869 9.41447L10.6854 1.9589C10.6854 1.95889 10.6854 1.95888 10.6854 1.95887C10.6854 1.803 10.6235 1.65352 10.5133 1.54331C10.403 1.43308 10.2535 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116"
                                                    fill="#165FE3"
                                                    stroke="#165FE3"
                                                    stroke-width="0.3"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_2821_158352">
                                                    <rect
                                                      width="14"
                                                      height="14"
                                                      fill="white"
                                                      transform="translate(0.203125 10) rotate(-45)"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </div>
                                          ),
                                          IndicatorSeparator: () => null,
                                          MultiValue: ({
                                            children,
                                            ...props
                                          }) => {
                                            const { selectProps } = props;
                                            const selectedCount =
                                              selectProps.value.length;
                                            if (props.index === 0) {
                                              return (
                                                <div className="flex items-center">
                                                  {children}
                                                  {selectedCount > 1 && (
                                                    <span className="ml-2 text-sm text-gray-500">
                                                      +{selectedCount - 1}
                                                    </span>
                                                  )}
                                                </div>
                                              );
                                            }
                                            return null;
                                          },
                                        }}
                                        isMulti
                                        name="people"
                                        onChange={(val) =>
                                          setSelectedStaffOptions(
                                            val as Option[]
                                          )
                                        }
                                        options={staffs}
                                        menuPlacement="top"
                                        className="rounded-lg w-full"
                                        placeholder="Select Staff"
                                      />
                                    </form>
                                  </div>
                                </div>
                              </div>
                            )}
                          {selectedChannelOption === "3" &&
                            selectedStaffOptions?.length > 0 && (
                              <div className="col-span-2 border-none bg-[#fff] h-auto mb-2">
                                <label
                                  htmlFor="ll"
                                  className="font-medium text-sm items-start justify-start whitespace-nowrap leading-[18.2px] text-[#333333]"
                                >
                                  Contacted with
                                </label>
                                <Select
                                  value={selectedContact}
                                  onValueChange={(val) => {
                                    setSelectedContact(val);
                                  }}
                                >
                                  <SelectTrigger className="w-full whitespace-nowrap">
                                    <SelectValue placeholder="Contacted with" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {!teamMember?.length ? (
                                      <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                    ) : (
                                      teamMember?.map((item) => (
                                        <SelectItem
                                          key={item?.id}
                                          value={String(item?.id)}
                                        >
                                          {item?.contactName}
                                        </SelectItem>
                                      ))
                                    )}
                                  </SelectContent>
                                </Select>
                              </div>
                            )}

                          {selectedStaffOptions?.length > 0 && (
                            <div className="col-span-2 border-none bg-[#fff] h-auto mb-2 w-full">
                              <form action="">
                                <label
                                  htmlFor="ll"
                                  className="font-medium text-sm leading-[18.2px]"
                                >
                                  Select team
                                </label>
                                <DateTimePicker
                                  fromDate={new Date("2000-01-01")}
                                  date={meetingTime}
                                  setDate={setMeetingTime}
                                />
                              </form>
                            </div>
                          )}
                          <SelectContent>
                            <SelectGroup>
                              {channel_options_inbound
                                // .filter((val) => val.label !== "Meeting")
                                .map((channel) => (
                                  <SelectItem
                                    className="cursor-pointer hover:bg-[#e5eff3]"
                                    key={channel.value}
                                    value={channel.value.toString()}
                                  >
                                    {channel.label}
                                  </SelectItem>
                                ))}
                            </SelectGroup>
                          </SelectContent>
                        </Select>

                        <Select
                          disabled={selectedType === "inbound"}
                          onValueChange={(val) => {
                            setSelectedType("outbound");
                            setSelectedChannelOption(val);
                          }}
                          value={
                            selectedType === "outbound"
                              ? selectedChannelOption
                              : ""
                          }
                        >
                          <SelectTrigger
                            hideIcon
                            className={`${
                              selectedType === "inbound"
                                ? "hidden"
                                : selectedType !== ""
                                ? "col-span-2"
                                : ""
                            } bg-[#E1EBFC] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap relative`}
                          >
                            <div className="flex gap-3 items-center">
                              <SelectValue placeholder="Partner contacted" />
                              {!selectedChannelOption && (
                                <ChevronDown className="h-4 w-4 text-blue-600 ml-0 pointer-events-none" />
                              )}
                            </div>
                            {selectedChannelOption && (
                              <X
                                className="h-4 w-4 z-50 text-blue-600 ml-2 cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setSelectedType("");
                                  setSelectedChannelOption("");
                                }}
                              />
                            )}
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              {channel_options_outbound?.map((channel) => {
                                if (
                                  [
                                    "Refferal",
                                    "Social Media",
                                    "Chat",
                                    "Walk-in",
                                  ].includes(channel?.label)
                                )
                                  return null;
                                return (
                                  <SelectItem
                                    className="cursor-pointer hover:bg-[#e5eff3]"
                                    key={channel.value}
                                    value={channel.value.toString()}
                                  >
                                    {channel.label === "Refferal"
                                      ? "Referral"
                                      : channel.label}
                                  </SelectItem>
                                );
                              })}
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                      </div>
                    </>
                  )}

                  <div className="grid grid-cols-2 gap-3">
                    {/* Optional: If you ever want to bring back the Prepare Quote button */}
                    {/* <button
                          onClick={handlePrepareQuote}
                          disabled={!buttonState()}
                          className="col-span-2 w-full h-12 text-sm text-blue-600 bg-white border border-blue-600 rounded-lg disabled:opacity-50 shadow-sm"
                        >
                          Prepare Quote
                        </button> */}

                    {isNextBtn ? (
                      <button
                        onClick={handleMobileViewClick}
                        disabled={!nextButtonState()}
                        className="col-span-2 w-full h-12 text-sm text-[#fff] bg-blue-600 rounded-[8px] disabled:opacity-50 shadow-md"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        onClick={handleAddInteraction}
                        disabled={!buttonState()}
                        className="col-span-2 w-full h-12 text-sm text-[#fff] bg-blue-600 rounded-[8px] disabled:opacity-50 shadow-md"
                      >
                        Submit
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 gap-3 mt-4">
                    {productDetails?.name?.toLowerCase() === "visa" && (
                      <button
                        disabled={extraDetails?.quote_requested}
                        className="px-4 py-[11px] text-sm text-center font-semibold border-blue-700 border rounded-lg text-blue-700 cursor-pointer disabled:cursor-not-allowed"
                      >
                        <label
                          htmlFor="upload_letter"
                          className="flex items-center text-center justify-center w-full gap-2.5 cursor-pointer"
                        >
                          <input
                            type="file"
                            id="upload_letter"
                            className="hidden"
                            accept=".pdf"
                            onChange={(e) =>
                              handleQuoteUploadVisa(
                                e?.target?.files?.[0] as File
                              )
                            }
                          />
                          <p>Upload Quotation</p>
                          <svg
                            width="15"
                            height="19"
                            viewBox="0 0 15 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H10.0546C10.3381 0 10.6083 0.12032 10.7979 0.33104L14.7433 4.71477C14.9086 4.8984 15 5.13669 15 5.38374V14.5C15 16.7091 13.2091 18.5 11 18.5H4.5C2.29086 18.5 0.5 16.7091 0.5 14.5V4Z"
                              fill="#165FE3"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.26 10.8978C10.9583 11.1817 10.4837 11.1672 10.1998 10.8655L7.7461 8.25736L5.2923 10.8655C5.0085 11.1672 4.5339 11.1817 4.2322 10.8978C3.9305 10.614 3.916 10.1394 4.1999 9.83766L6.8968 6.97106C7.3603 6.47836 8.1319 6.47836 8.5954 6.97106L11.2923 9.83766C11.5762 10.1394 11.5617 10.614 11.26 10.8978Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.74609 15.6016C7.33189 15.6016 6.99609 15.2658 6.99609 14.8516V7.35156C6.99609 6.93736 7.33189 6.60156 7.74609 6.60156C8.16029 6.60156 8.49609 6.93736 8.49609 7.35156V14.8516C8.49609 15.2658 8.16029 15.6016 7.74609 15.6016Z"
                              fill="white"
                            />
                            <path
                              d="M14.9922 6V5.38374C14.9922 5.13669 14.9008 4.8984 14.7355 4.71477L10.7901 0.33104C10.6005 0.12032 10.3303 0 10.0468 0H8.99219V2C8.99219 4.20914 10.7831 6 12.9922 6H14.9922Z"
                              fill="#98BDFF"
                            />
                          </svg>
                        </label>
                      </button>
                    )}
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          ) : (
            <div className="flex flex-1 justify-end h-full gap-8 sm:px-2 rounded-lg items-end p-2.5 bg-white-A700 w-full">
              {contactDetails?.lead_status !== "notinterested" &&
                contactDetails?.lead_status !== "notResponded" &&
                opportunityDetails?.isOpportunityOpen !== "open" &&
                activeTab === "interaction" && (
                  <div className="flex flex-col mt-1 w-full">
                    <hr className="" />
                    <div className="flex flex-col gap-2.5">
                      <div className="flex justify-between w-full">
                        <label
                          htmlFor="interaction_note"
                          className="text-sm font-medium"
                        >
                          Add interaction
                        </label>
                        {["6", "2"].includes(selectedChannelOption) && (
                          <EmailPopup notes={interactionNote} />
                        )}
                      </div>
                      <textarea
                        value={interactionNote}
                        onChange={(e) => setInteractionNote(e.target.value)}
                        className="rounded-xl border border-gray-border-gray-lite h-20 w-full"
                        name="interaction_note"
                        id="interaction_note"
                        placeholder="write here..."
                      />
                    </div>
                    <div className="flex w-full flex-wrap md:gap-5 sm:flex-col justify-between sm:items-start sm:gap-5 items-center">
                      <div className="flex gap-4 mt-2 sm:flex-col sm:items-start relative items-end">
                        {selectedChannelOption &&
                          selectedChannelOption === "3" && (
                            <>
                              <div className="">
                                <form className="w-[300px] sm:w-full" action="">
                                  <label
                                    htmlFor="ll"
                                    className="font-medium text-sm whitespace-nowrap leading-[18.2px] text-[#333333]"
                                  >
                                    Search & add team members
                                  </label>
                                  <ReactSelect
                                    closeMenuOnSelect={false}
                                    styles={{
                                      control: (provided, state) => ({
                                        ...provided,
                                        zIndex: 0,
                                        borderRadius: ".5rem",
                                        padding: ".3rem",
                                        borderColor: state.isFocused
                                          ? "#165FE3"
                                          : "#333333",
                                        boxShadow: "none",
                                        width: "100%",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1000,
                                        width: "100%",
                                      }),
                                      container: (provided) => ({
                                        // Added container styles
                                        ...provided,
                                        width: "100%",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }),
                                    }}
                                    components={{
                                      DropdownIndicator: () => (
                                        <div className="pr-1">
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clipPath="url(#clip0_2821_158352)">
                                              <path
                                                d="M10.0991 18.6318L10.0988 18.6318C9.94355 18.6313 9.79483 18.5695 9.68508 18.4597C9.57533 18.35 9.51347 18.2012 9.51301 18.046L9.513 18.0456L9.51149 10.59L2.05583 10.5884L2.04426 10.5884L2.04429 10.588C1.89676 10.5766 1.75897 10.5099 1.65846 10.4013C1.55795 10.2927 1.50211 10.1502 1.50211 10.0022C1.50211 9.85428 1.55795 9.71176 1.65846 9.60317C1.75897 9.49457 1.89676 9.42791 2.04429 9.4165L2.05583 9.4156L2.05583 9.41605L9.51143 9.41453L9.50991 1.95893L9.50992 1.9589C9.50992 1.80302 9.57184 1.65353 9.68206 1.54331C9.79228 1.43308 9.94178 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116L10.0977 1.52072L10.0977 1.37116M10.0991 18.6318C10.1763 18.6318 10.2528 18.6167 10.3241 18.5871L10.2669 18.4489L10.3241 18.5871C10.3955 18.5576 10.4603 18.5143 10.5149 18.4597C10.5695 18.4051 10.6128 18.3403 10.6423 18.269L10.5037 18.2116L10.6423 18.269C10.6718 18.1976 10.687 18.1212 10.6869 18.044L10.6869 10.59L18.1425 10.5884C18.1426 10.5884 18.1426 10.5884 18.1426 10.5884C18.2984 10.5884 18.4479 10.5265 18.5581 10.4163C18.6684 10.3061 18.7303 10.1566 18.7303 10.0007C18.7303 9.84482 18.6684 9.69532 18.5581 9.5851C18.4479 9.47488 18.2984 9.41295 18.1425 9.41295L18.1425 9.41295L10.6869 9.41447L10.6854 1.9589C10.6854 1.95889 10.6854 1.95888 10.6854 1.95887C10.6854 1.803 10.6235 1.65352 10.5133 1.54331C10.403 1.43308 10.2535 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116"
                                                fill="#165FE3"
                                                stroke="#165FE3"
                                                stroke-width="0.3"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_2821_158352">
                                                <rect
                                                  width="14"
                                                  height="14"
                                                  fill="white"
                                                  transform="translate(0.203125 10) rotate(-45)"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </div>
                                      ),
                                      IndicatorSeparator: () => null,
                                      MultiValue: ({ children, ...props }) => {
                                        const { selectProps } = props;
                                        const selectedCount =
                                          selectProps.value.length;

                                        // Only render the first item
                                        if (props.index === 0) {
                                          return (
                                            <div className="flex items-center">
                                              {children}
                                              {selectedCount > 1 && (
                                                <span className="ml-2 text-sm text-gray-500">
                                                  +{selectedCount - 1}
                                                </span>
                                              )}
                                            </div>
                                          );
                                        }

                                        // Return null for subsequent selections
                                        return null;
                                      },
                                    }}
                                    isMulti
                                    name="people"
                                    // value={selectedStaffOptions}
                                    onChange={(val) =>
                                      setSelectedStaffOptions(val as Option[])
                                    }
                                    options={staffs}
                                    menuPlacement="top"
                                    className="rounded-lg w-full"
                                    placeholder="Select Staff"
                                  />
                                </form>
                              </div>
                              <form action="">
                                <label
                                  htmlFor="ll"
                                  className="font-medium text-sm leading-[18.2px]"
                                >
                                  Select team
                                </label>
                                <DateTimePicker
                                  fromDate={new Date("2000-01-01")}
                                  date={meetingTime}
                                  setDate={setMeetingTime}
                                />
                              </form>
                            </>
                          )}
                        {selectedChannelOption === "3" && (
                          <Select
                            value={selectedContact}
                            onValueChange={(val) => {
                              setSelectedContact(val);
                            }}
                          >
                            <SelectTrigger className="w-[180px] whitespace-nowrap">
                              <SelectValue placeholder="Contacted with" />
                            </SelectTrigger>
                            <SelectContent>
                              {!teamMember?.length ? (
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                              ) : (
                                teamMember?.map((item) => (
                                  <SelectItem
                                    key={item?.id}
                                    value={String(item?.id)}
                                  >
                                    {item?.contactName}
                                  </SelectItem>
                                ))
                              )}
                            </SelectContent>
                          </Select>
                        )}
                        <Select
                          disabled={contactType === "outbound"}
                          onValueChange={(val) => {
                            if (val !== "3") {
                              setSelectedStaffOptions([]);
                              setMeetingTime(undefined);
                            }
                            setContactType("inbound");
                            setSelectedChannelOption(val);
                          }}
                          value={
                            contactType === "inbound"
                              ? selectedChannelOption
                              : ""
                          }
                        >
                          <SelectTrigger
                            className={`${
                              contactType === "outbound" ? "hidden" : ""
                            } bg-[#F9F9F9] border-none hover:bg-blue-100 focus:ring-0 whitespace-nowrap focus:ring-offset-0 [&>svg]:hidden`}
                          >
                            <SelectValue placeholder="I contacted" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              {channel_options_inbound?.map((channel) => (
                                <SelectItem
                                  className="cursor-pointer hover:bg-[#e5eff3]"
                                  key={channel.value}
                                  value={channel.value.toString()}
                                >
                                  {channel.label}
                                </SelectItem>
                              ))}
                            </SelectGroup>
                          </SelectContent>
                        </Select>

                        <Select
                          disabled={contactType === "inbound"}
                          onValueChange={(val) => {
                            if (val !== "3") {
                              setSelectedStaffOptions([]);
                              setMeetingTime(undefined);
                            }
                            setContactType("outbound");
                            setSelectedChannelOption(val);
                          }}
                          value={
                            contactType === "outbound"
                              ? selectedChannelOption
                              : ""
                          }
                        >
                          <SelectTrigger
                            className={`${
                              contactType === "inbound" ? "hidden" : ""
                            } bg-[#F9F9F9] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap [&>svg]:hidden`}
                          >
                            <SelectValue placeholder="Partner contacted" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              {channel_options_outbound?.map((channel) => {
                                if (
                                  [
                                    "Refferal",
                                    "Social Media",
                                    "Chat",
                                    "Walk-in",
                                  ].includes(channel.label)
                                )
                                  return null;
                                return (
                                  <SelectItem
                                    className="cursor-pointer hover:bg-[#e5eff3]"
                                    key={channel.value}
                                    value={channel.value.toString()}
                                  >
                                    {channel.label === "Refferal"
                                      ? "Referral"
                                      : channel.label}
                                  </SelectItem>
                                );
                              })}
                              <SelectItem
                                className="cursor-pointer hover:bg-[#e5eff3]"
                                value={"3"}
                              >
                                Meeting
                              </SelectItem>
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                        {selectedChannelOption && (
                          <button
                            className=""
                            onClick={() => {
                              setContactType("");
                              setSelectedChannelOption("");
                            }}
                          >
                            <XIcon
                              color="#165FE3"
                              className="w-4 border border-blue-700 rounded-full bg-[#E1EBFC] h-4"
                            />
                          </button>
                        )}
                      </div>
                      <div className=" flex-1 justify-end md:justify-start flex flex-wrap sm:flex-col gap-2 w-full">
                        {["Forex", "Remittance"].includes(
                          opportunityDetails?.productSubcategory as string
                        ) && (
                          <button
                            onClick={handlePrepareQuote}
                            disabled={!buttonState()}
                            className="px-4 hidden py-[11px] text-sm font-semibold rounded-lg text-blue-700 border-blue-700 border disabled:opacity-40"
                          >
                            Prepare Quotes
                          </button>
                        )}
                        <AlertDialog
                          open={dialogOpen}
                          onOpenChange={setDialogOpen}
                        >
                          <AlertDialogTrigger asChild>
                            <button
                              className="px-4 py-[11px] text-sm font-semibold rounded-lg bg-blue-700 text-white-A700 disabled:opacity-40"
                              onClick={handleClick}
                              disabled={!buttonState()}
                            >
                              Submit
                            </button>
                          </AlertDialogTrigger>
                          <AlertDialogPortal>
                            <AlertDialogOverlay className="bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                            <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl w-full animate-contentShow sm:max-w-[90%]">
                              <AlertDialogHeader className="flex text-left border-b rounded-t py-5 px-10">
                                <AlertDialogTitle className="font-bold capitalize p-0 text-lg text-black-label">
                                  Upload Picture
                                </AlertDialogTitle>
                              </AlertDialogHeader>
                              <FormProvider {...methods2}>
                                <div className="h-auto max-h-[80vh] overflow-auto w-full">
                                  <PhotoUpload />
                                </div>
                              </FormProvider>
                              <AlertDialogFooter className="flex justify-start items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                <AlertDialogCancel
                                  className="m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                  asChild
                                >
                                  <button
                                    onClick={() => {
                                      methods2.reset();
                                      methods2.clearErrors();
                                      setDialogOpen(false);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </AlertDialogCancel>
                                <AlertDialogAction
                                  className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 disabled:opacity-40"
                                  asChild
                                >
                                  <button
                                    disabled={
                                      !methods2.watch("office_photo") ||
                                      location === null
                                    }
                                    onClick={handleAddInteraction}
                                  >
                                    Done
                                  </button>
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialogPortal>
                        </AlertDialog>

                        <div className="hidden">
                          {pipelineType === "retail" &&
                            opportunityDetails?.productSubcategory !==
                              "Remittance" && (
                              <DocPopup
                                buttonState={buttonState}
                                onSubmit={handleRequestDoc}
                                selectedMode={selectedMode}
                                setSelectedMode={setSelectedMode}
                                expires={expires}
                                setExpires={setExpires}
                                popupnotes={popupnotes}
                                setPopupNotes={setPopupNotes}
                                channel={channel}
                                setChannel={setChannel}
                              />
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          )}
          {/* <div className="flex md:flex-col flex-row gap-2.5 w-full">
            <div className="flex flex-1 flex-col gap-2.5 items-start justify-start w-full">
              <Text className="font-rubik text-2xl md:text-[22px]  sm:text-xl w-auto pb-[10px]">
                {state?.name && Capitalize(state?.name)}
              </Text>
              <Text className="font-inter text-[#797D8C] text-sm w-auto">
                Partner ID: <span className="text-[#000000]">{state?.id}</span>
              </Text>
              <div className="flex text-[#797D8C]  flex-row font-inter gap-2.5 items-start justify-start w-full">
                <Text className="flex-1  text-sm w-auto">
                  Phone:
                  <span className="text-[#000000]">
                    {" "}
                    {state?.phone != "" ? state.phone : "N/A"}
                  </span>
                </Text>
                <Text className="flex-1  text-sm w-auto">
                  Email ID:{" "}
                  <span className="text-[#000000]">
                    {" "}
                    {state?.email ? state?.email : "N/A"}
                  </span>
                </Text>
              </div>
              <div className="flex flex-row font-inter gap-2.5 items-start justify-start w-full">
                <Text className="flex-1 text-[#797D8C] text-sm w-auto">
                  Relationship Manager:{" "}
                  <span
                    className="text-[#000000] cursor-pointer"
                    onClick={() =>
                      state?._realtionship_manager_channels?.id &&
                      state?._realtionship_manager_channels?.id != 0 &&
                      navigate(
                        `/staffdetails${state?._realtionship_manager_channels?.id}`,
                      )
                    }
                  >
                    {" "}
                    {state?._realtionship_manager_channels?.fname ?? "N/A"}{" "}
                  </span>
                </Text>
              </div>
              <div className="flex flex-row font-inter gap-2.5 items-start justify-start w-full">
                <Text className="flex-1 text-[#797D8C] text-sm w-auto">
                  Partner Contract:{" "}
                  {
                    <span
                      className={`${partner_contract_css} cursor-pointer border-[1px] p-[4px] rounded-md`}
                    >
                      {" "}
                      {state?.zoho_contract_status === "RequestSubmitted"
                        ? "Sent For Signing"
                        : state?.zoho_contract_status === "RequestRejected"
                          ? "Rejected"
                          : state?.zoho_contract_status === "RequestCompleted"
                            ? "Completed"
                            : state?.zoho_contract_status === "RequestExpired"
                              ? "Expired"
                              : "Pending"}{" "}
                    </span>
                  }
                </Text>
              </div>
            </div>
            <div className="flex flex-row gap-[15px] items-center justify-end mb-[102px] md:mt-0 mt-[0.46px] w-auto">
              <div className="flex flex-col items-center justify-end w-auto">
                {" "}
                {updatestatus !== "incomplete" &&
                updatestatus !== "pending" &&
                updatestatus !== "" ? (
                  <SelectBox
                    className="bg-white-A700 border border-gray-200_01 border-solid font-medium p-1.5  rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px] w-[130px]"
                    placeholderClassName="text-blue_gray-700 text-[12px] w-[130px]"
                    isSearchable={true}
                    isMulti={false}
                    value={updatestatus}
                    onChange={(e) => {
                      setUpdatestatus(e);
                      handleonChangeStatus(e);
                    }}
                    indicator={
                      <>
                        <div
                          className={`${partnerbgColor} absolute top-[40%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                        ></div>
                        <svg
                          width="22"
                          height="23"
                          viewBox="0 0 22 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            id="Background"
                            cx="11"
                            cy="11.75"
                            r="11"
                            fill="#2B2B2B"
                            fillOpacity="0.1"
                          />
                          <image
                            href="/images/img_arrowdown.svg"
                            x="0"
                            y="0"
                            width="22"
                            height="23"
                          />
                        </svg>
                      </>
                    }
                    options={statusOptionsList}
                    name="status"
                  />
                ) : (
                  <Button
                    onClick={resumeRegistration}
                    className="bg-blue-700 cursor-pointer h-auto py-2.5 rounded-md shadow-bs2  text-sm text-center text-white-A700 w-auto h-[40px] px-[10px]"
                  >
                    Resume Registration
                  </Button>
                )}
              </div>
              <Button className="hidden cursor-pointer font-inter  w-auto h-[40px] px-[10px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center text-[#252424]">
                Reset Password
              </Button>
            </div>
          </div> */}

          {/* {state?._onboarding_checklist && showOnboardingChecklist && (
            <div className="flex md:flex-col flex-row gap-5 w-full">
              <div className="bg-white-A700 flex flex-1 flex-col gap-[20px] h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
                <div className="flex flex-row w-full border-b border-gray-200 border-solid pb-2">
                  <Text
                    className="font-bold sm:pr-5 pr-[35px] pt-[3px] text-gray_900_01 text-sm uppercase w-full"
                    size="txtInterBold14"
                  >
                    OnBoarding Checklist
                  </Text>
                </div>
                <div className="flex flex-col w-full justify-start gap-[10px]">
                  {checkList.map((checkListItem) => {
                    return (
                      <div
                        key={checkListItem.task} // Add unique key prop
                        className="flex flex-row w-full justify-start items-center pt-[5px] gap-[8px]"
                      >
                        <input
                          className="text-[#000000] accent-black bg-gray-100 border-[#000000] hover:border-[#000000] focus:border-[#000000] border border-[2px] "
                          checked={checkListItem.value}
                          onClick={() => handleCheckBoxClick(checkListItem)}
                          type="checkbox"
                        />
                        <Text
                          className="text-gray_900_01 text-sm w-full"
                          size="txtInterRegular14"
                        >
                          {checkListItem.task}
                        </Text>
                      </div>
                    );
                  })}
                  {isCheckListUpdated && (
                    <Button className="mt-[10px] cursor-pointer bg-blue-700 text-white-A700 font-inter w-full max-w-[100px] px-[20px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center">
                      Save
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )} */}

          {/* <div className="flex md:flex-col flex-row gap-5 w-full">
            <div className="bg-white-A700 flex flex-1 flex-col gap-[20px] h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
              <div className="flex flex-row w-full border-b border-gray-200 border-solid pb-2">
                <Text
                  className="font-bold sm:pr-5 pr-[35px] pt-[3px] text-gray_900_01 text-sm uppercase w-full"
                  size="txtInterBold14"
                >
                  Bank account Details
                </Text>
                <Button
                  className="cursor-pointer bg-blue-700 text-white-A700 font-inter w-full max-w-[181px] px-[20px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center"
                  onClick={() => {
                    setVerifyBankAccount("");
                    setShowAddAccountModal(true);
                  }}
                >
                  Link Bank Account
                </Button>
              </div>

              {bankAccounts.length > 0 &&
                bankAccounts.map((bank) => {
                  let bankbgColor;
                  switch (bank.status) {
                    case "active":
                      bankbgColor = "bg-[#008000]";
                      break;
                    case "inactive":
                      bankbgColor = "bg-[#FFA500]";
                      break;
                    case "unverified":
                      bankbgColor = "bg-[#FFA500]";
                      break;
                    case "incomplete":
                      bankbgColor = "bg-[#008000]";
                      break;
                  }
                  return (
                    <div className="border border-gray-200 border-solid min-h-[150px] rounded-lg w-full px-[20px] py-[20px] gap-[10px]">
                      <div className="flex flex-row w-full items-center gap-[12px] pb-[12px]">
                        <div className="flex flex-row w-full items-center justify-start gap-[12px]">
                          <Text
                            className="font-inter font-medium text-gray_900_01 text-[14px] w-auto"
                            size="txtInterSemiBold14"
                          >
                            {bank.bank_name}
                          </Text>
                          {bank.primary_account && (
                            <Text
                              className="font-inter font-medium text-[#165FE3] text-[12px] w-auto"
                              size="txtInterRegular12"
                            >
                              {"Primary Bank"}
                            </Text>
                          )}
                        </div>
                        <div className="flex flex-row w-full items-center justify-end gap-[20px]">
                          <SelectBox
                            className="bg-white-A700 border border-gray-200_01 border-solid font-medium p-1.5  rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px] w-[110px]"
                            placeholderClassName="text-blue_gray-700 text-[12px] w-[130px]"
                            isSearchable={true}
                            isMulti={false}
                            value={bank.status}
                            isDisabled={true}
                            onChange={(e) => {}}
                            indicator={
                              <>
                                <div
                                  className={`${bankbgColor} absolute top-[30%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                                ></div>
                              </>
                            }
                            options={bankStatusOptionsList}
                            name="status"
                          />
                          <Button
                            className="relative cursor-pointer w-[30px] text-center font-inter px-[12px] py-[6px] rounded-md text-base text-center text-blue_gray_700"
                            onClick={() => {
                              if (editBankRow === bank.id) {
                                setEditBankRow("");
                              } else {
                                setEditBankRow(bank.id);
                              }
                            }}
                          >
                            <Img
                              className="text-end"
                              src="/images/img_ellipses.svg"
                              alt="Group"
                            />
                          </Button>
                          {editBankRow.toString() === bank.id.toString() && (
                            <div className="options-dropdown absolute z-10">
                              <ul className=" absolute top-[0px] w-[105px] top-[20px] left-[-30px] bg-[#FFFFFF] border border-solid border-gray_200_02">
                                <li
                                  className="flex flex-row justify-between items-center border-t border-solid border-gray_200_02 px-[12px] py-[6px] hover:bg-[#F4F7FF] text-[#3E3E3E] h-[32px] cursor-pointer"
                                  onClick={() => {
                                    setShowConfirmation(true);
                                    // setDeleteRow(item.id)
                                  }}
                                >
                                  <Text
                                    className="font-inter font-medium text-[#EE7373] text-[14px] w-auto"
                                    size="txtInterRegular16"
                                  >
                                    Remove
                                  </Text>
                                  <Img
                                    className=""
                                    width={9}
                                    height={9}
                                    src={deleteSvg2}
                                    alt="delete"
                                  />
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="relative flex flex-col w-full gap-[10px]">
                        <div
                          className={`${
                            bank.status === "incomplete" ||
                            bank.status === "unverified"
                              ? "opacity-20 "
                              : ""
                          } relative flex flex-col w-full gap-[10px]`}
                        >
                          <div className="flex flex-row w-full">
                            <div className="flex w-full justify-start items-center">
                              <Text
                                className="font-inter font-regular text-gray_900_01 text-[14px] w-auto"
                                size="txtInterRegular14"
                              >
                                Bank Account number
                              </Text>
                            </div>
                            <div className="flex w-full justify-end items-center">
                              <Text
                                className="font-inter font-medium text-[#165FE3] text-[14px] w-auto"
                                size="txtInterRegular14"
                              >
                                {bank.account_number}
                              </Text>
                            </div>
                          </div>
                          <div className="flex flex-row w-full">
                            <div className="flex w-full justify-start items-center">
                              <Text
                                className="font-inter font-regular text-gray_900_01 text-[14px] w-auto"
                                size="txtInterRegular14"
                              >
                                IFSC Code:
                              </Text>
                            </div>
                            <div className="flex w-full justify-end items-center">
                              <Text
                                className="font-inter font-medium text-[#165FE3] text-[14px] w-auto"
                                size="txtInterRegular14"
                              >
                                {bank.ifsc_code}
                              </Text>
                            </div>
                          </div>
                        </div>
                        {(bank.status === "unverified" ||
                          bank.status === "incomplete") && (
                          <div className="absolute top-[40%] left-[30%] flex flex-row sm:top-[5%] sm:left-[5%] sm:flex-col w-full justify-start gap-[10px] items-center">
                            <div className="h-full bg-[#F0F6FF] px-[6px] py-[6px] rounded-[6px]">
                              <Img
                                className="h-[18.52px] w-[18.52px] text-center"
                                src="/images/img_tick.svg"
                                alt="frame5724"
                              />
                            </div>
                            <Text
                              className="font-inter font-[400] font-regular text-[#111827] text-[14px] w-auto"
                              size="txtInterRegular16"
                            >
                              Verify your Bank Account
                            </Text>
                            {bank.status === "unverified" && (
                              <Text
                                className="cursor-pointer font-inter font-[400] font-regular text-[#165FE3] text-[14px] w-auto"
                                size="txtInterRegular16"
                                onClick={() => setVerifyBankAccount(bank.id)}
                              >
                                Click Here
                              </Text>
                            )}
                            {bank.status === "incomplete" && (
                              <Text
                                className="cursor-pointer font-inter font-[400] font-regular text-[#165FE3] text-[12px] w-auto"
                                size="txtInterRegular12"
                                onClick={() => {
                                  setVerifyBankAccount(bank.id);
                                  setShowAddAccountModal(true);
                                }}
                              >
                                Reupload the document
                              </Text>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              {bankAccounts.length == 0 && (
                <div className="border border-gray-200 border-solid min-h-[118px] rounded-lg w-full px-[20px] py-[20px] gap-[10px]">
                  <div className="flex flex-col justify-center items-center gap-[10px]">
                    <div className="flex bg-[#F0F6FF] w-[44px] h-[44px] justify-center items-center rounded-[4px]">
                      <Img
                        className="h-[32px] w-[32px] text-center"
                        src="/images/img_link.svg"
                        alt="frame5724"
                      />
                    </div>
                    <div className="flex pl-[30px] justify-center items-center">
                      <Text
                        className="font-bold text-[14px] sm:pr-5 pr-[35px] pt-[3px] text-gray_900_01 text-sm w-full"
                        size="txtInterRegular14"
                      >
                        No Bank Account is Linked
                      </Text>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div> */}

          {/* <div className="flex md:flex-col flex-row gap-5 w-full  text-[#797D8C] ">
            <div className="bg-white-A700 flex flex-1 flex-col gap-2.5 h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
              <Text className="border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                Type of Partner
              </Text>
              <div className="flex flex-row gap-2.5 items-center justify-between pt-[5px] w-full">
                <Text className=" text-sm w-auto">Organisation Type:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.pan_type === ""
                    ? "N.A."
                    : state?.pan_type &&
                      state?.pan_type?.slice(0, 1)?.toUpperCase() +
                        state?.pan_type?.slice(1)}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full">
                <Text className=" text-sm w-auto">Partner Trade:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.type}
                </Text>
              </div>
            </div>
            <div className="bg-white-A700 flex flex-1 flex-col gap-2.5 h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
              <Text className="border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                Id & Address Proof
              </Text>
              <div className="flex flex-row gap-2.5 items-center justify-between pt-[5px] w-full">
                <Text className=" text-sm w-auto">PAN Card:</Text>
                <Text
                  className="font-medium text-blue-700 text-sm w-auto cursor-pointer"
                  onClick={() => {
                    if (state?.pan == null) {
                      toast.error("PAN Card not uploaded");
                    } else {
                      setImgsrc(state?.pan?.url);
                      setShowimg(true);
                    }
                  }}
                >
                  {state?.masked_pan_no == ""
                    ? "Not Uploaded"
                    : state?.masked_pan_no}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full">
                <Text className=" text-sm w-auto">Aadhar card:</Text>
                <Text
                  className="font-medium text-blue-700 text-sm w-auto cursor-pointer"
                  onClick={() => {
                    if (state?.aadhar_front == null) {
                      toast.error("Aadhar Card not uploaded");
                    } else {
                      setImgsrc(state?.aadhar_front?.url);
                      setShowimg(true);
                    }
                  }}
                >
                  {state?.compliance?.aadhar_manually_verified
                    ? state?.masked_aadhar_no
                    : `*** ****${state?.masked_aadhar_no}`}
                </Text>
              </div>
            </div>
          </div> */}
          {/* <div className="bg-white-A700 flex flex-col font-inter gap-2.5 items-start justify-center md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
            <div className="flex flex-row w-full h-[36px]">
              <Text className="font-rubik text-md md:text-[22px]  sm:text-xl font-bold uppercase w-full pb-[10px]">
                Products
              </Text>
              <div className="flex flex-row items-center gap-[10px] justify-end w-auto">
                {productOptionsList && productOptionsList.length > 0 && (
                  <SelectBox
                    className="bg-white-A700 border border-gray-200_01 border-solid font-medium p-1.5 rounded-lg text-[13px] text-blue_gray-700 text-left pl-[20px] w-[160px]"
                    placeholderClassName="text-blue_gray-700 text-[12px] w-[130px]"
                    isSearchable={true}
                    isMulti={false}
                    value={product}
                    onChange={(e) => {
                      setProduct(e);
                      setProductStatus(
                        productOptionsList.find((item: any) => item.value === e)
                          ?.status,
                      );
                    }}
                    indicator={
                      <>
                        <div
                          className={`${partnerbgColor} absolute top-[40%] left-[-10px] h-1.5 rounded-[50%] w-1.5`}
                        ></div>
                        <svg
                          width="22"
                          height="23"
                          viewBox="0 0 22 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            id="Background"
                            cx="11"
                            cy="11.75"
                            r="11"
                            fill="#2B2B2B"
                            fillOpacity="0.1"
                          />
                          <image
                            href="/images/img_arrowdown.svg"
                            x="0"
                            y="0"
                            width="22"
                            height="23"
                          />
                        </svg>
                      </>
                    }
                    options={productOptionsList}
                    name="status"
                  />
                )}

                <Button
                  className="cursor-pointer bg-blue-700 text-white-A700 font-inter w-[150px] h-auto px-[20px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center"
                  onClick={() => {
                    setShowAddProduct(true);
                  }}
                >
                  + Add Product
                </Button>
              </div>
            </div>
            {commisionratedata && commisionratedata.length > 0 && (
              <>
                <Text className="text-[#797D8C] border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                  Commission Rate
                </Text>
                <div className="flex flex-col overflow-auto bg-white-A700 border border-indigo-50_01 border-solid font-rubik rounded w-full">
                  <ReactTable
                    columns={CommisionTableColumn}
                    data={commisionratedata}
                    headerClass="bg-[#E7E7ED]"
                  />
                </div>
              </>
            )}
            {productStatus && productStatus !== "approved" && (
              <div className="flex flex-row justify-end overflow-auto bg-white-A700  font-rubik rounded w-full">
                <Button
                  onClick={() => postapprovalcommision(updatecommisionratedata)}
                  className="float-right bg-blue-700 cursor-pointer font-inter w-[193px] ml-10 py-2.5 rounded-md shadow-bs2 text-base text-center text-white-A700"
                >
                  Approved Margin
                </Button>
              </div>
            )}
          </div> */}
          {/* <div className="flex md:flex-col flex-row font-inter gap-5 items-start justify-start w-full h-[60vh] text-[#797D8C] ">
            <div className="bg-white-A700 flex flex-1 flex-col gap-2.5 h-full items-start justify-start  md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
              <Text className="border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                Office Address
              </Text>
              <div className="flex flex-row gap-2.5 items-center justify-between py-[3px] w-full">
                <Text className=" text-sm w-auto">Address Line 1:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.address_line_1}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full py-[3px]">
                <Text className=" text-sm w-auto">Address Line 2:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.address_line_2}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full  py-[3px]">
                <Text className=" text-sm w-auto">City:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.city}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full  py-[3px]">
                <Text className=" text-sm w-auto">State:</Text>
                <Text className="font-medium text-[#000000]  text-sm w-auto">
                  {state?.state}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full  py-[3px]">
                <Text className=" text-sm w-auto">Pincode:</Text>
                <Text className="font-medium text-[#000000] text-sm w-auto">
                  {state?.pincode}
                </Text>
              </div>
              <div className="flex flex-row gap-2.5 items-center justify-between w-full  py-[3px]">
                <Text className=" text-sm w-auto">Property Type</Text>
                <Text
                  className="font-medium text-blue-700 text-sm w-auto cursor-pointer"
                  onClick={() => {
                    if (state?.address_proof) {
                      setImgsrc(state?.address_proof?.url);
                    }
                    setShowimg(true);
                  }}
                >
                  {state?.property_type}
                </Text>
              </div>
            </div>
            <div className="bg-white-A700 flex flex-1 flex-col gap-2.5 sm:min-h-[80px] h-full items-start justify-start md:px-10 sm:px-5 px-[50px] py-6 rounded-[10px] w-full">
              <Text className="border-b border-gray-200 border-solid font-bold pb-2 sm:pr-5 pr-[35px] pt-[3px]  text-sm uppercase w-full">
                Office Images
              </Text>
              <Img
                className="h-72 w-full"
                src="/images/img_frame5724.svg"
                alt="frame5724"
              />
              <div className="flex flex-row justify-between">
                {(state.photos === undefined ||
                  state?.photos === null ||
                  state?.photos?.length === 0) && (
                  <div className="text-[#000000]">Not Available</div>
                )}
              </div>
              <div className="flex flex-row justify-between ">
                <div className="flex flex-row gap-2.5">
                  {state.photos && state.photos.length > 0 && (
                    <Img
                      className="h-72 w-[70%]"
                      src={state.photos[0].url}
                      alt="Image 1"
                    />
                  )}
                  <div className="h-72 w-[30%] flex flex-col justify-start gap-2.5">
                    {state.photos && state.photos.length > 1 && (
                      <Img
                        className="h-24 w-full"
                        src={state.photos[1].url}
                        alt="Image 1"
                        onClick={() => {
                          if (state.photos && state.photos.length > 1) {
                            setImgsrc(state.photos[1].url);
                          }
                          setShowimg(true);
                        }}
                      />
                    )}
                    {state.photos && state.photos.length > 2 && (
                      <Img
                        className="h-24 w-full"
                        src={state.photos[2].url}
                        onClick={() => {
                          if (state.photos && state.photos.length > 2) {
                            setImgsrc(state.photos[2].url);
                          }
                          setShowimg(true);
                        }}
                        alt="Image 2"
                      />
                    )}
                    {state.photos && state.photos.length > 3 && (
                      <Img
                        className="h-24 w-full"
                        src={state.photos[3].url}
                        alt="Image 3"
                        onClick={() => {
                          if (state.photos && state.photos.length > 3) {
                            setImgsrc(state.photos[3].url);
                          }
                          setShowimg(true);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="flex flex-row items-start justify-start w-full">
            <div className="flex w-full justify-start">
              <Text className="text-black-900 text-xl w-auto">
                Partner Branch Details
              </Text>
            </div>
            <div className="flex w-full justify-end">
              <Text className="text-black-900 text-xl w-auto">
                <Button
                  className="cursor-pointer bg-blue-700 text-white-A700 font-inter w-[150px] h-auto px-[20px] py-1.5 rounded-md border-[2px] text-[14px] border-[#EAEAEA] text-base text-center"
                  onClick={() => {
                    navigate(`/branchregistration${state?.id}`);
                  }}
                >
                  Add Branch
                </Button>
              </Text>
            </div>
          </div> */}
          {/* {state._branch?.length === 0 ? (
            <div className="flex flex-col items-start justify-start w-full">
              <Text className="bg-[#FFFFFF] w-full  pb-2 sm:pr-5 px-[13px] pt-[3px]  text-sm uppercas">
                No Branches Found
              </Text>
            </div>
          ) : (
            <>
              <div className="flex flex-col overflow-auto bg-white-A700 border border-indigo-50_01 border-solid font-rubik rounded w-full">
                <ReactTable columns={BranchDetailColumn} data={branchdetails} />
              </div>
            </>
          )} */}
        </div>
      </div>
    </>
  );
};

export default PartnerDetailsPage;
